import React, { useState, useEffect, useMemo, useContext, useRef } from "react";

import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import Select from "react-select";
import moment from "moment";
import { toastError, toastSuccess } from "../../../../src/common/Toast";
import {
  DATA_EXPORT,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
  CUSTOM_SELECT_DROPDOWN_STYLE_VIEW,
  CUSTOM_SELECT_DROPDOWN_STYLE_VIEW_VREGISTER,
} from "../../../../src/common/Constant";
import Loader from "../../../components/Loader/Loader";
import SplittingConfirmationModal from "../../../components/Modal/SplittingModal";
// import Flatpickr from "react-flatpickr";
// import "flatpickr/dist/themes/material_blue.css";
import CommonDatePicker from "../../../components/DatePicker/CommonDatePicker";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
// import { Modal } from "bootstrap";
import { Box } from "@mui/material";
import ReportDate from "../../../components/Reports/ReportDate";
import QuickbookSyncMessageComponent from "../../../components/StoreConfig/QuickbookSyncMessageComponent";
import { checkUserPermission } from "../../../common/UserPermission";
import { useDebounce } from "../../../common/common";

function ViewRegisterQuickbookSc() {
  const {
    isManageSale,
    isManagePOSSale,
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    QuickBookViewRagister,
    AllowQBSync,
  } = useContext(AppContext);
  const paramObject = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  const loginuserid = localStorage.getItem("ID");

  const [loading, setLoading] = useState(false);
  const [showNewRow, setShowNewRow] = useState(false);
  const [isCheckApiCall, setIsCheckApiCall] = useState(false);

  const [searchText, setSearchText] = useState("");
  // const [referenceNo, setReferenceNo] = useState("");

  const [transactionTypeDropdown, setTransactionTypeDropdown] = useState([]);

  console.log(transactionTypeDropdown, "transactionTypeDropdown");
  const [selectTransactionType, setSelectTransactionType] = useState(1);

  const [supplierId, setSupplierId] = useState(0);
  const [customerId, setCustomerId] = useState(0);
  const [employeeId, setEmployeeId] = useState(0);

  const [payeePersonList, setPayeePersonList] = useState([]);

  const [chartOfAccountDropdown, setChartOfAccountDropdown] = useState([]);
  const [accountDropdown, setAccountDropdown] = useState([]);
  const [chartOfAccountDetails, setChartOfAccountDetails] = useState({});
  const [upperchartOfAccount, setupperChartOfAccount] = useState(0);
  // const [lowerchartofaccount, setLowerchartofaccount] = useState(0);
  const [billsquickid, setbillsquickid] = useState(0);
  // const [paymentDate, setPaymentDate] = useState(moment().format("YYYY-MM-DD"));
  // const [Payeequickid, setPayeequickid] = useState(0);
  const [BillInvoice, setBillInvoice] = useState(0);
  const [selectChartOfAccountId, setSelectChartOfAccountId] = useState(0);
  const [chartOfAccountQuickbookId, setChartOfAccountQuickbookId] = useState(0);
  // const [accountAmount, setAccountAmount] = useState(0);
  const [accountType, setAccountType] = useState(0);
  const [chartOfAccountId, setChartOfAccountId] = useState(0);
  // const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  // const [selectedInvoice, setSelectedInvoice] = useState("");
  const [billInvoiceSelect, setBillInvoiceSelect] = useState("");
  //   const [viewRegisterData, setViewRegisterData] = useState([]);
  const [pendinginvoice, setPendingInvoice] = useState([]);
  const [labelinvoice, setLabelInvoice] = useState([]);

  const [SingleLine, setsingleline] = useState(true);
  const [PaperLedgerMode, setPaperLedgerMode] = useState(false);

  const [toggleRowIndex, setToggleRowIndex] = useState(0);
  const [stateModal, setStateModal] = useState({ visible: null });

  const [pageSize, setPageSize] = useState(300);
  const [pageNum, setPageNum] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  let EDITPAYMENTS = "/receive-payment/:id";
  let EDITPAYBILLS = "/receiving-paybills/:id";
  let EDITJOURNALS = "/journal-entry/:id";
  let EDITDEPOSITS = "/bank-deposit/:id";
  let EDITBANKTRANSFER = "/manage-transfer/:id";
  let EDITEXPENSE = "/Expense/:id";

  let DELETEPAYMENTS = "/delete-receive-payment";
  let DELETEPAYBILLS = "/delete-paybills";
  let DELETEJOURNALS = "delete-journal-entry";
  let DELETEDEPOSITS = "/delete-bank-deposit";
  let DELETEBANKTRANSFER = "delete-transfer";
  let DELETEEXPENSE = "/delete-expense";

  let ADDPAYMENTS = "/receive-payment";
  let ADDPAYBILLS = "/receiving-paybills";
  let ADDJOURNALS = "/journal-entry";
  let ADDDEPOSITS = "/bank-deposit";
  let ADDBANKTRANSFER = "/manage-transfer";
  let ADDEXPENSE = "/Expense";

  console.log(SingleLine, "SingleLine");
  console.log(accountDropdown, "accountDropdown");
  // console.log(transactionTypeDropdown, "transactionTypeDropdown");
  console.log(chartOfAccountDetails, "chartOfAccountDetails");
  console.log(billInvoiceSelect, "billinvoicechnage");
  console.log(pendinginvoice, "billinvoicechnage");
  console.log(chartOfAccountId, "chartOfAccountId");
  console.log(upperchartOfAccount, "upperchartOfAccount");
  // console.log(lowerchartofaccount, "lowerchartofaccount");

  const [splits, setSplits] = useState([]);
  const [notlistingdata, setnotlistingdata] = useState([]);
  const [deleteData, setDeleteData] = useState({});

  //   const [currentPage, setCurrentPage] = useState(1);
  const [startIndex, setStartIndex] = useState(0);
  const [currentData, setCurrentData] = useState([]);
  const [opendropdown, setopendropdown] = useState(false);
  const [toggleItemsFilterSection, setToggleItemsFilterSection] =
    useState(false);

  const [expandedRowId, setExpandedRowId] = useState(null);
  const [expandedRowModule, setExpandedRowModule] = useState(null);
  // const [formData, setFormData] = useState({});
  const searchResultRef = useRef(null);

  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(1);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");

  console.log(startdate, enddate, "startdate");

  console.log(expandedRowId, "expandedRowId");

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        searchResultRef.current &&
        !searchResultRef.current.contains(event.target)
      ) {
        setopendropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchResultRef]);

  const accountMap = useMemo(() => {
    const map = {};
    accountDropdown.forEach((option) => {
      map[option.value] = option.label;
    });
    return map;
  }, [accountDropdown]);

  console.log(accountMap, "accountMap");

  const ITEMS_PER_PAGE = 300;

  //Date
  //Today
  // let today = moment().format("YYYY-MM-DD");
  // //Week
  // const startOfWeek = moment().startOf("week").format("YYYY-MM-DD");
  // const endOfWeek = moment().endOf("week").format("YYYY-MM-DD");
  // //This Month
  // const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  // const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  // //Last Month
  // const startOfLastMonth = moment()
  //   .subtract(1, "month")
  //   .startOf("month")
  //   .format("YYYY-MM-DD");
  // const endOfLastMonth = moment()
  //   .subtract(1, "month")
  //   .endOf("month")
  //   .format("YYYY-MM-DD");
  // //This Year
  // const startOfYear = moment().startOf("year").format("YYYY-MM-DD");
  // const endOfYear = moment().endOf("year").format("YYYY-MM-DD");
  // //Last Year
  // const startOfLastYear = moment()
  //   .subtract(1, "year")
  //   .startOf("year")
  //   .format("YYYY-MM-DD");
  // const endOfLastYear = moment()
  //   .subtract(1, "year")
  //   .endOf("year")
  //   .format("YYYY-MM-DD");

  // const startLast7DayDate = moment()
  //   .subtract(6, "days")
  //   .startOf("day")
  //   .format("YYYY-MM-DD");
  // const endLast7DayDate = moment().endOf("day").format("YYYY-MM-DD");

  // according to the state customeDate last 7 day
  // const [beginningDate, setBeginningDate] = useState(startLast7DayDate);
  // const [finalDate, setFinalDate] = useState(endLast7DayDate);
  // const [customeDate, setCustomDate] = useState(0);

  const [sortConfig, setSortConfig] = useState({
    column: "",
    order: "",
  });

  console.log(sortConfig, "checkck");

  const handlesetsingleline = (e) => {
    if (e.target.checked) {
      setsingleline(true);
      setPaperLedgerMode(false);
    } else {
      setPaperLedgerMode(true);
      setsingleline(false);
    }
  };

  const handlesetPaperLedgerMode = (e) => {
    if (e.target.checked) {
      setsingleline(false);
      setPaperLedgerMode(true);
    } else {
      setPaperLedgerMode(false);
      setsingleline(true);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // useEffect(() => {
  //   if (customeDate == 1) {
  //     setBeginningDate(today);
  //     setFinalDate(today);
  //   } else if (customeDate == 4) {
  //     setBeginningDate(startOfWeek);
  //     setFinalDate(endOfWeek);
  //   } else if (customeDate == 3) {
  //     setBeginningDate(startOfMonth);
  //     setFinalDate(endOfMonth);
  //   } else if (customeDate == 6) {
  //     setBeginningDate(startOfLastMonth);
  //     setFinalDate(endOfLastMonth);
  //   } else if (customeDate == 5) {
  //     setBeginningDate(startOfYear);
  //     setFinalDate(endOfYear);
  //   } else if (customeDate == 2) {
  //     setBeginningDate(startOfLastYear);
  //     setFinalDate(endOfLastYear);
  //   } else if (customeDate == 8) {
  //     setBeginningDate(startLast7DayDate);
  //     setFinalDate(endLast7DayDate);
  //   } else if (customeDate == 0) {
  //     setBeginningDate("");
  //     setFinalDate("");
  //   }
  // }, []);

  const accountTypeToTransactions = {
    Bank: [
      "Check",
      "Deposit",
      // "Sales Receipt",
      "Receive Payment",
      "Bill Payments",
      "Refund", // add for edit
      "Expense",
      "Bank Transfer",
      "Journal Entry",
      "Vendor Credit", // add for edit
      "CC Credit", // add for edit
      "Bill", // add for edit
    ],
    "Other Current Asset": [
      "Deposit",
      // "Sales Receipt",
      "Receive Payment",
      "Refund", // add for edit
      "Bank Transfer",
      "Journal Entry",
      "Expense", // add for edit
      "CC Credit", // add for edit
      "Check", // add for edit
      "Bill Payments", // add for edit
      "Bill", // add for edit
    ],
    "Fixed Asset": [
      "Bank Transfer",
      "Journal Entry",
      "Bill", // add for edit
      "Deposit", // add for edit
    ],
    "Other Asset": [
      "Bank Transfer",
      "Journal Entry",
      "Bill", // add for edit
      "Deposit", // add for edit
    ],
    "Credit Card": [
      "CC Expense",
      "Expense",
      "CC Credit",
      "Bill Payments",
      "Bank Transfer",
      "Journal Entry",
      "Bill", // add for edit,
      "Deposit", // add for edit
    ],
    "Other Current Liability": [
      "Bank Transfer",
      "Journal Entry",
      "Expense", // add for edit
      "CC Credit", // add for edit
      "Check", // add for edit
      "Bill", // add for edit
      "Deposit", // add for edit
    ],
    "Long Term Liability": [
      "Bank Transfer",
      "Journal Entry",
      "Bill", // add for edit
      "Deposit", // add for edit
    ],
    Equity: [
      "Bank Transfer",
      "Journal Entry",
      "Bill", // add for edit
      "Deposit", // add for edit
    ],
  };

  function getFilteredTransactions(accountType) {
    const allowedTransactions = accountTypeToTransactions[accountType] || [];
    return transactionTypeDropdown.filter((transaction) =>
      allowedTransactions.includes(transaction?.label)
    );
  }

  const filteredTransactions = getFilteredTransactions(
    chartOfAccountDetails?.AccountType
  );

  console.log(filteredTransactions, "filteredTransactions");

  console.log(chartOfAccountDetails, "chartOfAccountDetails");

  // const dateOptions = [
  //   { label: "All", value: 0 },
  //   { label: "Today", value: 1 },
  //   { label: "This Week", value: 4 },
  //   { label: "This Month", value: 3 },
  //   { label: "Last Month", value: 6 },
  //   { label: "This Year", value: 5 },
  //   { label: "Last Year", value: 2 },
  //   { label: "Custom", value: 7 },
  //   { label: "Last 7 Day", value: 8 },
  // ];

  const selectDropdownStyles = {
    control: (provided, state) => ({
      ...provided,
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc",
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
  };

  const inputStyles = {
    width: "92%",
    display: "block",
    // padding: '0.375rem 0.75rem',
    fontSize: "12px",
    // marginLeft: "5px",
    fontWeight: 400,
    lineHeight: 1.5,
    color: "#212529",
    // backgroundColor: '#fff',
    backgroundClip: "padding-box",
    border: "1px solid #ced4da",
    appearance: "none",
    borderRadius: "2px",
    transition: "border-color .15s ease-in-out, box-shadow .15s ease-in-out",
  };

  // const handleDateFilter = (event) => {
  //   // console.log(event, "eventtt");
  //   setCustomDate(event?.value);
  //   if (event?.value == 1) {
  //     setBeginningDate(today);
  //     setFinalDate(today);
  //   } else if (event?.value == 4) {
  //     setBeginningDate(startOfWeek);
  //     setFinalDate(endOfWeek);
  //   } else if (event?.value == 3) {
  //     setBeginningDate(startOfMonth);
  //     setFinalDate(endOfMonth);
  //   } else if (event?.value == 6) {
  //     setBeginningDate(startOfLastMonth);
  //     setFinalDate(endOfLastMonth);
  //   } else if (event?.value == 5) {
  //     setBeginningDate(startOfYear);
  //     setFinalDate(endOfYear);
  //   } else if (event?.value == 2) {
  //     setBeginningDate(startOfLastYear);
  //     setFinalDate(endOfLastYear);
  //   } else if (event?.value == 8) {
  //     setBeginningDate(startLast7DayDate);
  //     setFinalDate(endLast7DayDate);
  //   } else if (event?.value == 0) {
  //     setBeginningDate(today);
  //     setFinalDate(today);
  //   } else {
  //     setBeginningDate(today);
  //     setFinalDate(today);
  //   }
  // };

  //Date
  // const handleDate = (event) => {
  //   if (event && event.length > 0) {
  //     // console.log(event?.target?.value, "eventisss92");
  //     setBeginningDate(event);
  //     setCustomDate(7);
  //   }
  // };

  // const handleEndDate = (event) => {
  //   if (event && event.length > 0) {
  //     // console.log(event?.target?.value, "eventisss92");
  //     setFinalDate(event);
  //     setCustomDate(7);
  //   }
  //   // setCustomDate(7);
  // };

  const transactionType = () => {
    // payee Api
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/getalltransactiontype?isshowviewregister=1`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const transactionType = res.data.ResponseData.map((u) => ({
          label: u.Name,
          value: u.ID,
        }));
        setTransactionTypeDropdown(transactionType);
        console.log("res280", res.data.ResponseData);
      });
  };

  const payeeAPI = () => {
    // Payee Api
    axios
      .get(
        `${config.appointmentBaseUrl}/appointments/appointmentpersonddl?isCustomer=0`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const appointmentPersonOptions = res.data.ResponseData.map((u) => {
          const UserType =
            u.IsCustomer === 1
              ? "Customer"
              : u.IsCustomer === 0
              ? "Supplier"
              : "Employee";
          return {
            label: `${u.FirstName} (${UserType})`,
            value: u.Id,
            QuickBookId: u.QuickBookId,
            IsCustomer: u.IsCustomer,
            UserType: UserType,
            Type: "payee",
          };
        });
        setPayeePersonList(appointmentPersonOptions);
        // console.log("res ", appointmentPersonOptions);
      });
  };

  const latestCheckNumberAPI = () => {
    // let selectedRowsData = viewRegisterData[0];
    // let AccountID = selectedRowsData?.AccountID;

    axios
      .get(
        `${config.receivingBaseUrl}/receivings/getlatestchecknumberbyaccount?accountid=${paramObject?.id}&paymenttypeid=0&Module=ViewRegister`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )

      .then((res) => {
        let takeNumber = res.data.ResponseData[0]?.NextRefno;
        // setReferenceNo(takeNumber);
        const updatedCurrentData = [...currentData];
        updatedCurrentData[0] = {
          ...updatedCurrentData[0],
          RefNo: takeNumber,
        };
        setCurrentData(updatedCurrentData);

        // const updatedViewRegisterData = [...viewRegisterData];
        // updatedViewRegisterData[0] = {
        //   ...updatedViewRegisterData[0],
        //   RefNo: takeNumber,
        // };
        // setViewRegisterData(updatedViewRegisterData);
      });
    setIsCheckApiCall(false);
  };

  const newTransactionTypeDropdownOption = transactionTypeDropdown.filter(
    (el) => el.value != 3 && el.value != 8 && el.value != 9
  );

  const AccountAPI = () => {
    // Chart of Account Dropdown for account id
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        // const accountTypeDropdownOption = res.data.ResponseData?.filter(
        //   (e) => e?.IsViewRegister == 1
        // )?.map((u) => ({
        //   label: u.Name,
        //   value: u.ID,
        //   amount: u.Amount,
        //   QuickbookId: u.QuickbookId,
        //   AccountType: u.AccountType,
        //   type: "account",
        // }));

        console.log(
          res.data.ResponseData,
          "resdataResponseDataresdataResponseData"
        );

        const responseData = res.data.ResponseData;

        // Full data without filter
        const allAccounts = responseData.map((u) => ({
          label: u.Name,
          value: u.ID,
          amount: u.Amount,
          QuickbookId: u.QuickbookId,
          AccountType: u.AccountType,
          type: "account",
          ChartOfAccountTypeID: u.ChartOfAccountTypeID,
          AccountTypeID: u.AccountTypeID,
          ParentAmount: u.ParentAmount,
          ParentAccountID: u.ParentAccountID,
          parentName: u.ParentName ? u.ParentName.trim() : "",
          AccountFullName: u.AccountFullName,
        }));

        // Filtered data for view register
        const accountTypeDropdownOption = responseData
          .filter((item) => item.IsViewRegister === 1)
          .map((u) => ({
            label: u.Name,
            value: u.ID,
            amount: u.Amount,
            QuickbookId: u.QuickbookId,
            AccountType: u.AccountType,
            type: "account",
            ChartOfAccountTypeID: u.ChartOfAccountTypeID,
            AccountTypeID: u.AccountTypeID,
            ParentAmount: u.ParentAmount,
            ParentAccountID: u.ParentAccountID,
            parentName: u.ParentName ? u.ParentName.trim() : "",
            AccountFullName: u.AccountFullName,
            QBOpenBalance: u.QBOpenBalance,
          }));

        setChartOfAccountDropdown(accountTypeDropdownOption);
        setAccountDropdown(allAccounts);

        setChartOfAccountDetails(
          accountTypeDropdownOption?.find((el) => el?.value == paramObject?.id)
        );

        const accontfiler = res.data.ResponseData.filter(
          (el) => el.ID == paramObject?.id
        );
        console.log(accontfiler, accontfiler[0]?.QuickbookId, "5555");
        setupperChartOfAccount(accontfiler[0]?.QuickbookId);

        const filterAccount = res.data.ResponseData.find(
          (option) => option?.ID == paramObject.id
        );
        console.log(filterAccount, paramObject.id, "filterAccount check");

        if (filterAccount) {
          setChartOfAccountQuickbookId(filterAccount?.QuickbookId);
          // setAccountAmount(filterAccount?.Amount);
          setAccountType(filterAccount?.AccountTypeID);
          setChartOfAccountId(filterAccount?.ChartOfAccountTypeID);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // function calculateBalance(entries) {
  //   let finalBalance = 0;
  //   const ArrayVRegister = [];

  //   entries.forEach((entry, index) => {
  //     // Update balance based on deposit and payment

  //     // if (entry?.Type == "Opening Balance") {
  //       if (entry?.Type === "Credit Card") {
  //       finalBalance -= Number(entry?.Deposit);
  //       finalBalance += Number(entry?.Payment);
  //       console.log(
  //         "+",
  //         Number(entry?.Payment),
  //         "-",
  //         Number(entry?.Deposit),
  //         finalBalance,
  //         entry?.AccountTypeID,
  //         "finalBalance 11"
  //       );
  //     } else {
  //       console.log(entry?.ID, entry?.Payment, "payment");
  //       finalBalance += Number(entry?.Deposit);
  //       finalBalance -= Number(entry?.Payment);
  //       console.log(
  //         "-",
  //         Number(entry?.Payment),
  //         "+",
  //         Number(entry?.Deposit),
  //         finalBalance,
  //         entry?.AccountTypeID,
  //         "finalBalance 0"
  //       );
  //     }
  //     // Store the balance after each entry
  //     ArrayVRegister.push({
  //       ...entry,
  //       entryNumber: index + 1,
  //       Deposit: entry?.Deposit,
  //       Payment: entry?.Payment,
  //       Balance: finalBalance,
  //       // Balance:
  //       //   entry?.Type == "Opening Balance"
  //       //     ? Number(entry?.Payment)
  //       //     : finalBalance,
  //       Date: entry?.Date ? moment(entry?.Date).format("MM/DD/YYYY") : "",
  //     });
  //   });

  //   // const OrderByDesc = ArrayVRegister?.sort((a, b) => {
  //   //   return (
  //   //     moment(b.CreatedModifiedDate).toDate() -
  //   //     moment(a.CreatedModifiedDate).toDate()
  //   //   );
  //   // });
  //   const OrderByDesc = ArrayVRegister;

  //   // console.log(OrderByDesc.map(el => el.ID), "OrderByDesc");
  //   console.log(OrderByDesc, "OrderByDesc");
  //   // ArrayVRegister
  //   return {
  //     OrderByDesc,
  //     finalBalance,
  //   };
  // }

  // latest
  // function calculateBalance(entries) {
  //   let finalBalance = 0;
  //   const ArrayVRegister = [];

  //   // Iterate over entries in reverse order
  //   for (let index = entries.length - 1; index >= 0; index--) {
  //     const entry = entries[index];

  //     if (entry?.Type === "Credit Card") {
  //       finalBalance -= Number(entry?.Deposit);
  //       finalBalance += Number(entry?.Payment);
  //       // console.log(
  //       //   "+",
  //       //   Number(entry?.Payment),
  //       //   "-",
  //       //   Number(entry?.Deposit),
  //       //   finalBalance,
  //       //   entry?.AccountTypeID,
  //       //   "finalBalance 11"
  //       // );
  //     } else {
  //       console.log(entry?.ID, entry?.Payment, "payment");
  //       finalBalance += Number(entry?.Deposit);
  //       finalBalance -= Number(entry?.Payment);
  //       // console.log(
  //       //   "-",
  //       //   Number(entry?.Payment),
  //       //   "+",
  //       //   Number(entry?.Deposit),
  //       //   finalBalance,
  //       //   entry?.AccountTypeID,
  //       //   "finalBalance 0"
  //       // );
  //     }

  //     // Store the balance after each entry
  //     ArrayVRegister.unshift({
  //       ...entry,
  //       entryNumber: entries.length - index,
  //       Deposit: entry?.Deposit,
  //       Payment: entry?.Payment,
  //       Balance: finalBalance,
  //       Date: entry?.Date ? moment(entry?.Date).format("MM/DD/YYYY") : "",
  //     });
  //   }

  //   console.log(ArrayVRegister, "OrderByDesc");

  //   return {
  //     OrderByDesc: ArrayVRegister,
  //     finalBalance,
  //   };
  // }

  const handleViewRegisterAPI = (
    searchtext,
    selectTransactionType,
    customerid,
    supplierid,
    startdate,
    enddate,
    selectChartOfAccountId,
    employeeId
  ) => {
    if (selectReport == 2 && (!startdate || !enddate)) {
      return;
    }
    setLoading(true);
    setCurrentData([]);
    axios
      .get(
        `${
          config.accountingBaseUrl
        }/chartofaccounts/accountviewregisterV2?searchtext=${searchtext}&transactiontype=${selectTransactionType}&customerid=${
          customerid ? customerid : 0
        }&supplierid=${supplierid ? supplierid : 0}&employeeid=${
          employeeId ? employeeId : 0
        }&startdate=${startdate}&enddate=${enddate}&locationid=${locationid}&accountid=${selectChartOfAccountId}&pageSize=${pageSize}&pageNum=${pageNum}&orderColumn=${
          sortConfig?.column
        }&currentOrder=${sortConfig?.order}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("response ==>", res.data.ResponseData);
        // const openingBalanceIndex = res.data.ResponseData.findIndex(
        //   (item) => item.Type === "Opening Balance"
        // );

        // if (openingBalanceIndex !== -1) {
        //   const [openingBalance] = res.data.ResponseData.splice(
        //     openingBalanceIndex,
        //     1
        //   );
        //   res.data.ResponseData.push(openingBalance);
        // }

        const newarr = res.data.ResponseData?.map((el) => {
          return {
            ...el,
            showDelete: true,
            Payment: el?.Payment ? parseFloat(el?.Payment).toFixed(2) : 0,
            Deposit: el?.Deposit ? parseFloat(el?.Deposit).toFixed(2) : 0,
            showAll: el.Type === "Expense" ? true : false,
            TransactionTypeID:
              el?.isCreditCard == 1 ? 21 : el.TransactionTypeID,
            Type: el?.isCreditCard == 1 ? "CC Credit" : el.Type,
          };
        });

        // console.log(newarr, "balance data check");
        // const FinalData = calculateBalance(newarr);
        // console.log(FinalData, "balance data check");

        // setViewRegisterData(FinalData?.OrderByDesc); //newarr //ArrayVRegister
        // setCurrentData(FinalData?.OrderByDesc?.slice(0, ITEMS_PER_PAGE));
        // setViewRegisterData(newarr); //newarr //ArrayVRegister
        setCurrentData(newarr);
        if (newarr?.length > 0) {
          setTotalRecords(newarr[0]?.TotalRecords);
        }
        // setViewRegisterFinalBalance(FinalData?.finalBalance); //newarr

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const fetchdata = (
    transactionid,
    payeeid,
    payeeusertype,
    locationid,
    startdate,
    enddate
  ) => {
    setPendingInvoice([]);
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/viewregisterpendinginvoiceandbills?transactiontypeid=${transactionid}&payeeid=${payeeid}&payeeusertype=${payeeusertype}&locationid=${locationid}&startdate=${startdate}&enddate=${enddate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("invoicedata", res.data.ResponseData[0].QuickBookId);

        const datadropdown = res.data.ResponseData?.map((u, i) => {
          return {
            label: u.Name,
            value: u.ID,
            total: u.PaymentBalance,
            txnTotal: u.Total,
            QuickBookId: u.QuickBookId,
            Type: "Bills",
          };
        });

        setPendingInvoice(datadropdown);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSubmit = async (type, index, issplit) => {
    let requestPayload = {};

    const transaferAccountAdjust = (
      FromAccount,
      ToAccount,
      FromCOA,
      TOCOA,
      deposit,
      payment,
      field
    ) => {
      if (FromCOA == 2 || FromCOA == 4) {
        if (Number(deposit || 0) > 0) {
          if (field == "FromAccountID") {
            return ToAccount || 0;
          } else {
            return FromAccount || 0;
          }
        }

        if (Number(payment || 0) > 0) {
          if (field == "FromAccountID") {
            return FromAccount || 0;
          } else {
            return ToAccount || 0;
          }
        }
      } else {
        if (Number(deposit || 0) > 0) {
          if (field == "FromAccountID") {
            return FromAccount || 0;
          } else {
            return ToAccount || 0;
          }
        }

        if (Number(payment || 0) > 0) {
          if (field == "FromAccountID") {
            return ToAccount || 0;
          } else {
            return FromAccount || 0;
          }
        }
      }
    };

    if (type == "edit") {
      let selectedRowsData = currentData[index];
      console.log(selectedRowsData, "66656");
      // setLowerchartofaccount(selectedRowsData?.AccountQuickbookId);
      requestPayload = {
        id: selectedRowsData?.ID > 0 ? selectedRowsData?.ID : 0,
        ItemsId: selectedRowsData?.ItemsId > 0 ? selectedRowsData?.ItemsId : 0,
        transactiontypeid: selectedRowsData?.TransactionTypeID,
        date: moment(selectedRowsData?.Date).format("YYYY-MM-DD"),
        // date: paymentDate,
        refno: selectedRowsData?.RefNo,
        payeeid: selectedRowsData?.PayeeId,
        payeeusertype: selectedRowsData?.PayeeUserType,
        // accountid: paramObject?.id ? paramObject?.id : 0,
        // accountcategoryid: selectedRowsData?.AccountID,
        accountid:
          selectedRowsData?.TransactionTypeID != 13
            ? selectedRowsData?.FromAccountID || 0
            : transaferAccountAdjust(
                paramObject?.id ? paramObject?.id : 0,
                selectedRowsData?.AccountID,
                chartOfAccountId,
                selectedRowsData?.categoryChartOfAccountId,
                selectedRowsData?.Deposit,
                selectedRowsData?.Payment,
                "FromAccountID"
              ) || 0, // FromAccountID
        accountcategoryid:
          selectedRowsData?.TransactionTypeID != 13
            ? selectedRowsData?.AccountID
            : transaferAccountAdjust(
                paramObject?.id ? paramObject?.id : 0,
                selectedRowsData?.AccountID,
                chartOfAccountId,
                selectedRowsData?.categoryChartOfAccountId,
                selectedRowsData?.Deposit,
                selectedRowsData?.Payment,
                "ToAccountID"
              ) || 0,

        // Upperaccount: upperchartOfAccount,
        // lowerchartofaccount: selectedRowsData?.AccountQuickbookId,
        // selectedRowsData?.TransactionTypeID == 13
        //   ? selectedRowsData?.QuickbookId
        //   : selectedRowsData?.AccountQuickbookId, //lowerchartofaccount
        Payeequickbookid: selectedRowsData?.PayeeQuickbookId,
        BillInvoice: BillInvoice,
        billsquickid: billsquickid,
        QuickbookId: selectedRowsData?.QuickbookId,
        memo: selectedRowsData?.Memo,
        payment: selectedRowsData?.Payment,
        deposit: selectedRowsData?.Deposit,
        cr: selectedRowsData?.cr,
        locationid: locationid,
        loginuserid: loginuserid,
        issplit: issplit ? issplit : 0,
        module: selectedRowsData?.Module,
        CheckRefNum: selectedRowsData?.RefNo,
        accountType: accountType, // no need
        // categoryAccountTypeID: selectedRowsData?.categoryAccountType || 0, // no need
        chartOfAccountId: chartOfAccountId,
        categoryChartOfAccountId:
          selectedRowsData?.categoryChartOfAccountId || 0, // no need

        FromAccountQBId:
          selectedRowsData?.TransactionTypeID != 13
            ? selectedRowsData?.FromAccountQB
            : transaferAccountAdjust(
                upperchartOfAccount,
                selectedRowsData?.AccountQuickbookId,
                chartOfAccountId,
                selectedRowsData?.categoryChartOfAccountId,
                selectedRowsData?.Deposit,
                selectedRowsData?.Payment,
                "FromAccountID"
              ) || 0,
        ToAccountQBId:
          selectedRowsData?.TransactionTypeID != 13
            ? selectedRowsData?.ToAccountQB
            : transaferAccountAdjust(
                upperchartOfAccount,
                selectedRowsData?.AccountQuickbookId,
                chartOfAccountId,
                selectedRowsData?.categoryChartOfAccountId,
                selectedRowsData?.Deposit,
                selectedRowsData?.Payment,
                "ToAccountID"
              ) || 0,
        ItemQBID: selectedRowsData?.ItemQBID || 0,
        QuickBookViewRagister: QuickBookViewRagister,
      };
    } else {
      let selectedRowsData = currentData[0];

      // Check if selectedRowsData.AccountId matches an AR or AP account
      const isARorAP = accountDropdown?.some(
        (acc) =>
          acc.value == selectedRowsData?.AccountID &&
          (acc.AccountFullName ==
            "Accounts Receivable (A/R) (Accounts Receivable)" ||
            acc.AccountFullName == "Accounts Payable (A/P) (Accounts Payable)")
      );

      console.log(selectedRowsData, "selectedRowsDataselectedRowsData");
      // setLowerchartofaccount(selectedRowsData?.AccountQuickbookId)
      if (
        (selectedRowsData?.TransactionTypeID == 6 && isARorAP) ||
        (selectedRowsData?.TransactionTypeID == 12 && isARorAP) ||
        selectedRowsData?.TransactionTypeID == 7 ||
        selectedRowsData?.TransactionTypeID == 11
      ) {
        if (selectedRowsData?.PayeeId < 1) {
          toastError("Please Select Payeee");
          return;
        }
      }

      if (
        selectedRowsData?.TransactionTypeID != 11 &&
        selectedRowsData?.TransactionTypeID != 7
      ) {
        if (selectedRowsData?.AccountID < 1) {
          toastError("Please Select Account");
          return;
        }
      }

      if (selectedRowsData?.TransactionTypeID == 7 && BillInvoice == 0) {
        toastError("Please Select Bill");
        return;
      }

      if (selectedRowsData?.Deposit < 1) {
        if (selectedRowsData?.Payment < 1) {
          toastError("Please FIll Amount");
          return;
        }
      }

      requestPayload = {
        id: 0,
        ItemsId: 0,
        transactiontypeid: selectedRowsData.TransactionTypeID,
        date: selectedRowsData?.Date,
        refno: selectedRowsData?.RefNo,
        payeeid: selectedRowsData?.PayeeId,
        payeeusertype: selectedRowsData?.PayeeUserType,
        accountid:
          selectedRowsData?.TransactionTypeID != 13
            ? selectedRowsData?.FromAccountID || 0
            : transaferAccountAdjust(
                paramObject?.id ? paramObject?.id : 0,
                selectedRowsData?.AccountID,
                chartOfAccountId,
                selectedRowsData?.categoryChartOfAccountId,
                selectedRowsData?.Deposit,
                selectedRowsData?.Payment,
                "FromAccountID"
              ) || 0, // FromAccountID
        accountcategoryid:
          selectedRowsData?.TransactionTypeID != 13
            ? selectedRowsData?.AccountID
            : transaferAccountAdjust(
                paramObject?.id ? paramObject?.id : 0,
                selectedRowsData?.AccountID,
                chartOfAccountId,
                selectedRowsData?.categoryChartOfAccountId,
                selectedRowsData?.Deposit,
                selectedRowsData?.Payment,
                "ToAccountID"
              ) || 0,
        // Upperaccount: selectedRowsData?.TransactionTypeID != 13 ?
        //   upperchartOfAccount
        //   : upperchartOfAccount,
        // lowerchartofaccount: lowerchartofaccount,
        Payeequickbookid: selectedRowsData?.PayeeQuickbookId,
        BillInvoice: BillInvoice,
        billsquickid: billsquickid,
        memo: selectedRowsData?.Memo,
        payment: selectedRowsData?.Payment,
        deposit: selectedRowsData?.Deposit,
        cr: selectedRowsData?.cr,
        locationid: locationid,
        loginuserid: loginuserid,
        issplit: 0,
        quickbookid: selectedRowsData?.PayeeQuickbookId,
        // ChartOfAccountTypeID: selectedRowsData?.ChartOfAccountTypeID || 0,
        CheckRefNum: selectedRowsData?.CheckRefNum,
        accountType: accountType,
        categoryAccountTypeID: selectedRowsData?.categoryAccountType || 0,

        chartOfAccountId: chartOfAccountId || 0,
        categoryChartOfAccountId:
          selectedRowsData?.categoryChartOfAccountId || 0,

        FromAccountQBId:
          selectedRowsData?.TransactionTypeID != 13
            ? upperchartOfAccount
            : transaferAccountAdjust(
                upperchartOfAccount,
                selectedRowsData?.AccountQuickbookId,
                chartOfAccountId,
                selectedRowsData?.categoryChartOfAccountId,
                selectedRowsData?.Deposit,
                selectedRowsData?.Payment,
                "FromAccountID"
              ) || 0,
        ToAccountQBId:
          selectedRowsData?.TransactionTypeID != 13
            ? selectedRowsData?.AccountQuickbookId
            : transaferAccountAdjust(
                upperchartOfAccount,
                selectedRowsData?.AccountQuickbookId,
                chartOfAccountId,
                selectedRowsData?.categoryChartOfAccountId,
                selectedRowsData?.Deposit,
                selectedRowsData?.Payment,
                "ToAccountID"
              ) || 0,
        QuickBookViewRagister: QuickBookViewRagister,
      };
    }

    // return;
    let selectedRowsData = currentData[index];
    if (
      type == "edit" &&
      (selectedRowsData?.TransactionTypeID == 12 ||
        selectedRowsData?.TransactionTypeID == 14 ||
        selectedRowsData?.TransactionTypeID == 6)
    ) {
      await axios
        .get(
          `${config.accountingBaseUrl}/chartofaccounts/getEditRistrictedBymodule?module=${selectedRowsData?.Type}&moduleId=${selectedRowsData?.ID}&AccountId=${selectedRowsData?.AccountID}`
        )
        .then((res) => {
          console.log(res.data.ResponseData[0]?.ID, "7454565");
          if (res.data.ResponseData[0]?.ID == 1) {
            toastError("Payment Already Initiated Cannot Modified");
            return;
          } else {
            setLoading(true);
            axios
              .post(
                `${config.accountingBaseUrl}/chartofaccounts/accountviewregisterupsert`,
                requestPayload,
                {
                  headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    "Access-Control-Allow-Origin": "*",
                    Authorization: token,
                  },
                }
              )
              .then((res) => {
                console.log("res data ==========>>>>", res);
                if (res.data.ResponseCode === "SUCCESS") {
                  toastSuccess(SUCCESS_MESSAGE);
                  setShowNewRow(false);
                  setExpandedRowId(0);
                  // handleRowClick(viewRegisterData[index]?.ID, viewRegisterData[index]?.Module)
                  handleViewRegisterAPI(
                    searchText,
                    selectTransactionType,
                    customerId,
                    supplierId,
                    startdate,
                    enddate,
                    paramObject?.id,
                    employeeId
                  );
                  AccountAPI();
                } else {
                  toastError(ERROR_MESSAGE);
                }
                setLoading(false);
              })
              .catch((error) => {
                console.log(error);
                setLoading(false);
              });
          }
        })
        .catch((err) => {});
    } else {
      setLoading(true);
      axios
        .post(
          `${config.accountingBaseUrl}/chartofaccounts/accountviewregisterupsert`,
          requestPayload,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log("res data ==========>>>>", res);
          if (res.data.ResponseCode === "SUCCESS") {
            toastSuccess(SUCCESS_MESSAGE);
            setShowNewRow(false);
            setExpandedRowId(0);
            // handleRowClick(viewRegisterData[index]?.ID, viewRegisterData[index]?.Module)
            handleViewRegisterAPI(
              searchText,
              selectTransactionType,
              customerId,
              supplierId,
              startdate,
              enddate,
              paramObject?.id,
              employeeId
            );
            AccountAPI();
          } else {
            toastError(ERROR_MESSAGE);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    }
  };

  // const descRowsData = viewRegisterData?.sort((a, b) => {
  //   return b?.row_num - a?.row_num;
  // });

  const handleEdit = (value, id, isExpanse, RecSaleID) => {
    console.log(value, id, isExpanse, RecSaleID, "handelEdit");
    // return
    if (isExpanse === "Expense" || isExpanse === "CC Credit") {
      navigate(`/Expense/${id}`);
    }

    if (value == 8 || value == 9) {
      // navigate(`/manage-sales/${id}`);
      navigate(
        isManageSale == 1
          ? `/manage-sales/${id}`
          : isManagePOSSale == 1
          ? `/pos/${id}`
          : "#"
      );
    }

    if (value == 6 || value == 15) {
      navigate(`/Expense/${id}`);
    }
    if (value == 5) {
      navigate(
        isManageSale == 1
          ? `/manage-receiving/${RecSaleID}`
          : isManagePOSSale == 1
          ? `/pos-receiving/${RecSaleID}`
          : "#"
      );
      // navigate(`/manage-receiving/${RecSaleID}`);
    }
    if (value == 3) {
      navigate(
        isManageSale == 1
          ? `/manage-receiving/${id}`
          : isManagePOSSale == 1
          ? `/pos-receiving/${id}`
          : "#"
      );
      // navigate(`/manage-receiving/${id}`);
    }

    if (value == 7) {
      navigate(`/receiving-paybills/${id}`);
    }

    if (value == 11) {
      // navigate(`/recvpayment/${id}`);
      navigate(`/receive-payment/${id}`);
    }

    if (value == 12) {
      navigate(`/bank-deposit/${id}`);
    }

    if (value == 13) {
      navigate(`/manage-transfer/${id}`);
    }

    if (value == 14) {
      navigate(`/journal-entry/${id}`);
    }
    if (value == 23) {
      navigate(`/manage-Items/${id}`);
    }
    if (value == 24) {
      navigate(`/new-inventory-count/${id}`);
    }
  };

  const handleSort = (column) => {
    // let direction = "asc";
    // if (sortConfig.key == column && sortConfig.direction == "asc") {
    //   direction = "desc";
    // }
    const filterColumnName = column == "✔" ? "cr" : column;
    const order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);

    // console.log(
    //   "filterColumnName",
    //   filterColumnName,
    //   currentData,
    //   column,
    //   order
    // );
    // const sortedData = [...currentData].sort((a, b) => {
    //   return order === "desc"
    //     ? b[filterColumnName] - a[filterColumnName]
    //     : a[filterColumnName] - b[filterColumnName];
    // });

    setSortConfig({ column: filterColumnName, order: order });
    // setCurrentData(sortedData);
    // console.log("sortedData", column, sortedData);
  };

  const handleSortstring = (column) => {
    const order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);

    // const sortedData = [...currentData].sort((a, b) => {
    //   if (order === "desc") {
    //     return a[column] < b[column] ? 1 : -1;
    //   } else {
    //     return a[column] > b[column] ? 1 : -1;
    //   }
    // });
    setSortConfig({ column, order });
    // setCurrentData(sortedData);
  };

  //Delete  after check
  const handleDeleteClick = (item, index) => {
    const deleteFinalData = {
      DeleteIndex: index,
      ID: item?.ID,
      QuickbookId: item?.QuickbookId,
      Deposit: item?.Deposit,
      Payment: item?.Payment,
      TransactionTypeID: item?.TransactionTypeID,
      TransactionType: item?.TransactionTypeID,
      ModuleDelete: item?.Module,
    };

    console.log(deleteFinalData, "deleteFinalData 1");

    // return;
    // if (item.QuickbookId > 0) {
    //   if (item.Module === "RECEIVEPAYMENT") {
    //     setLoading(true);
    //     axios
    //       .get(
    //         `${config.accountingBaseUrl}/chartofaccounts/deletedataviewregister?ID=${item.ID}&Module=RECEIVEPAYMENT`,
    //         {
    //           headers: {
    //             "Content-Type": "application/json;charset=UTF-8",
    //             Authorization: token,
    //           },
    //         }
    //       )
    //       .then((res) => {
    //         setLoading(false);
    //         //console.log(res.data.ResponseData, "mydear");
    //         setnotlistingdata(res.data.ResponseData);

    //         setStateModal({ visible: index });
    //       })
    //       .catch((error) => {
    //         setLoading(false);
    //       });
    //   } else if (item.Module === "PAYBILLS") {
    //     setLoading(true);
    //     axios
    //       .get(
    //         `${config.accountingBaseUrl}/chartofaccounts/deletedataviewregister?ID=${item.ID}&Module=PAYBILLS`,
    //         {
    //           headers: {
    //             "Content-Type": "application/json;charset=UTF-8",
    //             Authorization: token,
    //           },
    //         }
    //       )
    //       .then((res) => {
    //         setLoading(false);
    //         //console.log(res.data.ResponseData, "mydear");
    //         setnotlistingdata(res.data.ResponseData);

    //         setStateModal({ visible: index });
    //       })
    //       .catch((error) => {
    //         setLoading(false);
    //       });
    //   } else {
    //     setnotlistingdata([]);
    //     setStateModal({ visible: index });
    //   }
    // } else {

    setnotlistingdata([]);
    setStateModal({ visible: index });

    setDeleteData(deleteFinalData);
    // setDeleteIndex(index);
    // setID(item.ID);
    // setviewregasterQuickbookIds(item.QuickbookId);
    // setDeposit(item.Deposit);
    // setPayment(item.Payment);
    // setTransactionTypeID(item.TransactionTypeID);
    // setTransactionType(item.TransactionTypeID);
    // setModuleDelete(item.Module);
  };

  const handlePayeeType = (event) => {
    if (event?.IsCustomer == 1) {
      // customer
      setSupplierId(0);
      setEmployeeId(0);
      setCustomerId(event?.value);
    } else if (event?.IsCustomer == 2) {
      // employeee
      setSupplierId(0);
      setCustomerId(0);
      setEmployeeId(event?.value);
    } else {
      // supplier
      setSupplierId(event?.value);
      setCustomerId(0);
      setEmployeeId(0);
    }
  };

  // after check
  const handleConfirmDelete = (index) => {
    // const rows = [...rowsData];
    // rows.splice(deleteIndex, 1);
    // setRowsData(rows);

    setStateModal({ visible: null });

    const DeleteFinalData = {
      id: deleteData?.ID, // state
      quickbookid: deleteData?.QuickbookId, // state
      Deposit: deleteData?.Deposit, // state
      Payment: deleteData?.Payment, // state
      rootquickbookid: chartOfAccountQuickbookId, //
      TransactionTypeID: deleteData?.TransactionTypeID, // state
      loginuserid: loginuserid,
      transactiontype: deleteData?.TransactionType, // state
      module: deleteData?.ModuleDelete, // state
      notlistingdata: notlistingdata,
    };

    console.log(DeleteFinalData, "deleteFinalData 2");
    // return;

    axios
      .post(
        `${config.accountingBaseUrl}/chartofaccounts/viewregisterdelete`,
        DeleteFinalData,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setnotlistingdata([]);
        setDeleteData([]);
        toastSuccess(SUCCESS_MESSAGE);
        handleViewRegisterAPI(
          searchText,
          selectTransactionType,
          customerId,
          supplierId,
          startdate,
          enddate,
          paramObject?.id, //accountId,
          employeeId
        );
        AccountAPI();
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  // new row cancle
  const handleRemove = () => {
    let NewViewRegisterData = [...currentData];
    NewViewRegisterData.shift();

    // setViewRegisterData([]);
    setPendingInvoice([]);
    setBillInvoiceSelect("");
    setBillInvoice(0);
    setTimeout(() => {
      // setViewRegisterData(NewViewRegisterData);
      setCurrentData(NewViewRegisterData);
      setPageNum(1);
      setStartIndex(0);
    }, 100);

    setShowNewRow(false);
    setLabelInvoice([]);
  };

  const handleRowClick = (row, rowmodule) => {
    console.log(row, "787854");
    if (expandedRowId === row) {
      // Collapse the expanded row
      setExpandedRowId(null);
      setExpandedRowModule(null);
      if (row == 0) {
        handleRemove();
      }
    } else {
      // Expand the clicked row and prefill formData
      setExpandedRowId(row);
      setExpandedRowModule(rowmodule);
      // setFormData(row);
    }
  };

  const handleAccountChange = (e) => {
    setupperChartOfAccount(e?.QuickbookId);

    setSupplierId(0);
    setEmployeeId(0);
    setCustomerId(0);
    setSelectTransactionType(1);

    // setAccountAmount(e?.amount);
    e?.value != undefined && navigate(`/vregister/${e?.value}`);
  };

  const handleInputChange = (event, index, fieldName, currentDataIndex) => {
    console.log(event, index, fieldName, currentDataIndex, "131");

    // if (event?.Type == "payee") {
    // setPayeequickid(event?.QuickBookId);
    // }
    // if (event?.type == "account") {
    //   setLowerchartofaccount(event?.QuickbookId);
    // }
    if (event?.Type == "Bills") {
      // setbillsquickid(event?.QuickBookId);
    }
    if (fieldName == "BillInvoice") {
      setBillInvoice(event?.value);
      setbillsquickid(event?.QuickBookId);
    }
    if (fieldName === "Type") {
      const updatedData = [...currentData];

      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: event?.label,
        ["TransactionTypeID"]: event?.value,
        ["PayeeId"]: 0,
        ["RefNo"]: "",
        ["Memo"]: "",
        ["Deposit"]: 0,
        ["Payment"]: 0,
        // ["AccountID"]: (event?.value === 11 || event?.value === 7) ? paramObject?.id : 0,
        ["AccountID"]: 0,
        ["AccountQuickbookId"]: 0,
        ["PayeeUserType"]:
          event?.value == 6 ||
          event?.value == 13 ||
          event?.value == 14 ||
          event?.value == 20 ||
          event?.value == 21 ||
          event?.value == 15 ||
          event?.value == 12
            ? ""
            : event?.value == 17 || event?.value == 11 || event?.value == 22
            ? "Customer"
            : "Supplier", // Supplier  7 id
        ["showAll"]:
          event?.value == 6 ||
          event?.value == 13 ||
          event?.value == 14 ||
          event?.value == 20 ||
          event?.value == 21 ||
          event?.value == 15 ||
          event?.value == 12
            ? true
            : false,
      };
      console.log(updatedData[currentDataIndex], "updateType");
      setPendingInvoice([]);
      // setSelectedInvoice("");
      setLabelInvoice([]);
      setBillInvoiceSelect(null);
      setCurrentData(updatedData);

      if (event?.value == 15 || event?.value == 7) {
        setIsCheckApiCall(true);
      }
      // if (event?.value == 7 || event?.value == 11) {
      //   if (payee) {
      //     fetchdata(
      //       event?.value,
      //       payeeid,
      //       payeeusertype,
      //       locationid,
      //       startdate,
      //       finalDate
      //     );
      //   }
      //   setDropdown(true);
      //   setType(true);
      // }

      // for current data
      // const updatedCurrentData = [...currentData];
      // updatedCurrentData[currentDataIndex] = {
      //     ...updatedCurrentData[currentDataIndex],
      //     [fieldName]: event?.label,
      //     ["TransactionTypeID"]: event?.value,
      //     ["PayeeId"]: 0,
      //     ["RefNo"]: "",
      //     ["Memo"]: "",
      //     ["Deposit"]: 0,
      //     ["Payment"]: 0,
      //     // ["AccountID"]: (event?.value === 11 || event?.value === 7) ? paramObject?.id : 0,
      //     ["AccountID"]: 0,
      //     ["AccountQuickbookId"]: 0,
      //     ["PayeeUserType"]:
      //     event?.value == 6 ||
      //     event?.value == 13 ||
      //     event?.value == 14 ||
      //     event?.value == 20 ||
      //     event?.value == 21 ||
      //     event?.value == 15 ||
      //     event?.value == 12
      //         ? ""
      //         : event?.value == 17 || event?.value == 11 || event?.value == 22
      //         ? "Customer"
      //         : "Supplier", // Supplier  7 id
      //     ["showAll"]:
      //     event?.value == 6 ||
      //     event?.value == 13 ||
      //     event?.value == 14 ||
      //     event?.value == 20 ||
      //     event?.value == 21 ||
      //     event?.value == 15 ||
      //     event?.value == 12
      //         ? true
      //         : false,
      // };
      // console.log(updatedCurrentData, "updatedCurrentDatacheck");

      // setCurrentData(updatedCurrentData);
      // if( event?.value == 15 ||  event?.value == 7){
      //     setIsCheckApiCall(true);
      // }
    } else if (fieldName === "Date") {
      const updatedData = [...currentData];
      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: event,
      };

      setCurrentData(updatedData);

      // for current data
      // const updatedCurrentData = [...currentData];
      // updatedCurrentData[currentDataIndex] = {
      //     ...updatedCurrentData[currentDataIndex],
      //     [fieldName]: event,
      // };
      // setCurrentData(updatedCurrentData);
    } else if (fieldName === "RefNo") {
      // const updatedData = [...viewRegisterData];
      // updatedData[index] = {
      //     ...updatedData[index],
      //     [fieldName]: event,
      // };
      // setViewRegisterData(updatedData);

      // for current data
      const updatedCurrentData = [...currentData];
      updatedCurrentData[currentDataIndex] = {
        ...updatedCurrentData[currentDataIndex],
        [fieldName]: event,
      };
      setCurrentData(updatedCurrentData);
    } else if (fieldName === "PayeeId") {
      if (
        currentData[currentDataIndex]?.TransactionTypeID == 14 &&
        currentData[currentDataIndex]?.AccountType == "Accounts Receivable" &&
        (event?.IsCustomer == 0 ||
          event?.IsCustomer !== 1 ||
          event?.IsCustomer !== 0)
      ) {
        toastError(
          "Business Validation Error: When you use Accounts Receivable, you must choose a customer in the Name field"
        );
      } else if (
        currentData[currentDataIndex]?.TransactionTypeID == 14 &&
        currentData[currentDataIndex]?.AccountType == "Accounts Payable" &&
        (event?.IsCustomer == 1 ||
          event?.IsCustomer !== 1 ||
          event?.IsCustomer !== 0)
      ) {
        toastError(
          "Business Validation Error: When you use Accounts Payable, you must choose a Supplier in the Name field"
        );
      } else {
        // const updatedData = [...viewRegisterData];
        // updatedData[index] = {
        // ...updatedData[index],
        // [fieldName]: event?.value,
        // ["Payee"]: event?.label,
        // ["PayeeQuickbookId"]: event?.QuickBookId,
        // ["PayeeUserType"]:
        //     event?.IsCustomer == 1
        //     ? "Customer"
        //     : event?.IsCustomer == 0
        //     ? "Supplier"
        //     : "Employee",
        // };
        // setBillInvoiceSelect(null);

        // if (
        // updatedData[index]?.TransactionTypeID == 7 ||
        // updatedData[index]?.TransactionTypeID == 11
        // ) {
        //     fetchdata(
        //         updatedData[index]?.TransactionTypeID,
        //         updatedData[index]?.PayeeId,
        //         updatedData[index]?.PayeeUserType,
        //         locationid,
        //         "",
        //         ""
        //         // startdate,
        //         // finalDate
        //     );
        // }
        // setViewRegisterData(updatedData);

        // for current data
        const updatedCurrentData = [...currentData];
        updatedCurrentData[currentDataIndex] = {
          ...updatedCurrentData[currentDataIndex],
          [fieldName]: event?.value,
          ["Payee"]: event?.label,
          ["PayeeQuickbookId"]: event?.QuickBookId,
          ["PayeeUserType"]:
            event?.IsCustomer == 1
              ? "Customer"
              : event?.IsCustomer == 0
              ? "Supplier"
              : "Employee",
        };

        setBillInvoiceSelect(null);

        if (
          updatedCurrentData[currentDataIndex]?.TransactionTypeID == 7 ||
          updatedCurrentData[currentDataIndex]?.TransactionTypeID == 11
        ) {
          fetchdata(
            updatedCurrentData[currentDataIndex]?.TransactionTypeID,
            updatedCurrentData[currentDataIndex]?.PayeeId,
            updatedCurrentData[currentDataIndex]?.PayeeUserType,
            locationid,
            "",
            ""
            // startdate,
            // finalDate
          );
        }

        setCurrentData(updatedCurrentData);
      }
    } else if (fieldName === "AccountID") {
      console.log(
        currentData[currentDataIndex].TransactionTypeID,
        "typeofview",
        event
      );
      if (
        currentData[currentDataIndex]?.TransactionTypeID == 14 &&
        (currentData[currentDataIndex]?.PayeeUserType == "Supplier" ||
          currentData[currentDataIndex]?.PayeeUserType == "Employee") &&
        event?.AccountType == "Accounts Receivable"
      ) {
        toastError(
          "Business Validation Error: When you use Accounts Receivable, you must choose a customer in the Name field"
        );
      } else if (
        currentData[currentDataIndex]?.TransactionTypeID == 14 &&
        (currentData[currentDataIndex]?.PayeeUserType == "Customer" ||
          currentData[currentDataIndex]?.PayeeUserType == "Employee") &&
        event?.AccountType == "Accounts Payable"
      ) {
        toastError(
          "Business Validation Error: When you use Accounts Payable, you must choose a Supplier in the Name field"
        );
      } else {
        // const updatedData = [...viewRegisterData];
        // updatedData[index] = {
        // ...updatedData[index],
        // // [fieldName]: event,
        // [fieldName]: event?.value,
        // ["AccountType"]: event?.AccountType,
        // ["AccountQuickbookId"]: event?.QuickbookId,

        // // ["ChartOfAccountTypeID"]: event?.ChartOfAccountTypeID,
        // ["categoryChartOfAccountId"]: event?.ChartOfAccountTypeID,
        // ["categoryAccountType"]: event?.AccountTypeID,
        // ...(updatedData[index]?.IsOppositeEntry == 0
        //     ? {
        //         ["ToAccountQB"]: event?.QuickbookId,
        //     }
        //     : {
        //         ["FromAccountQB"]: event?.QuickbookId,
        //     }),
        // };
        // setViewRegisterData(updatedData);

        // for current data
        const updatedCurrentData = [...currentData];
        updatedCurrentData[currentDataIndex] = {
          ...updatedCurrentData[currentDataIndex],
          [fieldName]: event?.value,
          ["AccountType"]: event?.AccountType,
          ["AccountQuickbookId"]: event?.QuickbookId,
          ["ToAccountQB"]: event?.QuickbookId,
          // ["ChartOfAccountTypeID"]: event?.ChartOfAccountTypeID,
          ["categoryChartOfAccountId"]: event?.ChartOfAccountTypeID,
          ["categoryAccountType"]: event?.AccountTypeID,
          ...(updatedCurrentData[currentDataIndex]?.IsOppositeEntry == 0
            ? {
                ["ToAccountQB"]: event?.QuickbookId,
              }
            : {
                ["FromAccountQB"]: event?.QuickbookId,
              }),
        };

        setCurrentData(updatedCurrentData);
      }
    } else if (fieldName === "Memo") {
      // const updatedData = [...viewRegisterData];
      // updatedData[index] = {
      //     ...updatedData[index],
      //     [fieldName]: event?.target?.value,
      // };
      // setViewRegisterData(updatedData);

      // for current data
      const updatedCurrentData = [...currentData];
      updatedCurrentData[currentDataIndex] = {
        ...updatedCurrentData[currentDataIndex],
        [fieldName]: event?.target?.value,
      };
      setCurrentData(updatedCurrentData);
    } else if (fieldName === "Payment" || fieldName === "Deposit") {
      console.log(currentData, "viewRegisterDataviewRegisterData");

      // const updatedData = [...viewRegisterData];
      // updatedData[index] = {
      //     ...updatedData[index],
      //     [fieldName]: event?.target?.value,
      // };

      // Check if one field has a value and the other doesn't, then update accordingly
      // if (fieldName === "Payment" && updatedData[index]["Deposit"]) {
      //     updatedData[index]["Deposit"] = 0;
      // } else if (fieldName === "Deposit" && updatedData[index]["Payment"]) {
      //     updatedData[index]["Payment"] = 0;
      // }

      // // If field is Deposit and type is 15, change type to 12
      // if (
      //     fieldName === "Deposit" &&
      //     updatedData[index].TransactionTypeID === 15 &&
      //     updatedData[index].ID == 0
      // ) {
      //     updatedData[index].RefNo = "";
      //     updatedData[index].TransactionTypeID = 12;
      // }

      // console.log(updatedData, "updatedDataupdatedData1");

      // setViewRegisterData(updatedData);

      // for current data
      const updatedCurrentData = [...currentData];
      updatedCurrentData[currentDataIndex] = {
        ...updatedCurrentData[currentDataIndex],
        [fieldName]: event?.target?.value,
      };

      // Check if one field has a value and the other doesn't, then update accordingly
      if (
        fieldName === "Payment" &&
        updatedCurrentData[currentDataIndex]["Deposit"]
      ) {
        updatedCurrentData[currentDataIndex]["Deposit"] = 0;
      } else if (
        fieldName === "Deposit" &&
        updatedCurrentData[currentDataIndex]["Payment"]
      ) {
        updatedCurrentData[currentDataIndex]["Payment"] = 0;
      }

      // Also apply type change here for currentData
      if (
        fieldName === "Deposit" &&
        updatedCurrentData[currentDataIndex].TransactionTypeID === 15 &&
        updatedCurrentData[currentDataIndex].ID == 0
      ) {
        updatedCurrentData[currentDataIndex].TransactionTypeID = 12;
      }

      console.log(updatedCurrentData, "updatedDataupdatedData2");

      setCurrentData(updatedCurrentData);
    } else if (fieldName === "BillInvoice") {
      console.log(event, "events==>");

      setBillInvoiceSelect(event?.value ? event?.value : null);

      let event1 = event ? [event] : [];

      setLabelInvoice(event1);

      // const updatedData = [...viewRegisterData];
      // updatedData[0]["BillQuickbookId"] = event?.QuickBookId;
      // if (updatedData[0]?.TransactionTypeID == 7) {
      //     if (chartOfAccountId == 2 || chartOfAccountId == 4) {
      //     updatedData[0]["Deposit"] = 0;
      //     updatedData[0]["Payment"] = event?.total;
      //     } else {
      //     updatedData[0]["Deposit"] = event?.total;
      //     updatedData[0]["Payment"] = 0;
      //     }
      // } else if (updatedData[0]?.TransactionTypeID == 11) {
      //     // if(chartOfAccountId == 2 || chartOfAccountId == 4){
      //     //   updatedData[0]["Deposit"] = 0;
      //     //   updatedData[0]["Payment"] = event?.total;
      //     // }else{
      //     //   updatedData[0]["Deposit"] = event?.total;
      //     //   updatedData[0]["Payment"] = 0;
      //     // }
      //     updatedData[0]["Payment"] = 0;
      //     updatedData[0]["Deposit"] = event?.total;
      // }

      // updatedData[0] = {
      //     ...updatedData[0],
      //     [fieldName]: event1.map((el) => el.value).join(","),
      // };

      // setSelectedInvoice(event1.map((el) => el.value).join(","));
      // setViewRegisterData(updatedData);

      // for current data
      const updatedCurrentData = [...currentData];
      updatedCurrentData[0]["BillQuickbookId"] = event?.QuickBookId;
      if (updatedCurrentData[0]?.TransactionTypeID == 7) {
        if (chartOfAccountId == 2 || chartOfAccountId == 4) {
          updatedCurrentData[0]["Deposit"] = 0;
          updatedCurrentData[0]["Payment"] = event?.total;
        } else {
          updatedCurrentData[0]["Deposit"] = event?.total;
          updatedCurrentData[0]["Payment"] = 0;
        }
        // updatedCurrentData[0]["Deposit"] = 0;
        // updatedCurrentData[0]["Payment"] = event?.total;
      } else if (updatedCurrentData[0]?.TransactionTypeID == 11) {
        updatedCurrentData[0]["Payment"] = 0;
        updatedCurrentData[0]["Deposit"] = event?.total;
      }

      updatedCurrentData[0] = {
        ...updatedCurrentData[0],
        [fieldName]: event1.map((el) => el.value).join(","),
      };

      // setSelectedInvoice(event1.map((el) => el.value).join(","));
      setCurrentData(updatedCurrentData);
    }
    // else if (fieldName === "cr") {
    //   const updatedData = [...viewRegisterData];
    //   updatedData[index] = {
    //     ...updatedData[index],
    //     [fieldName]: event?.target?.value,
    //   };
    //   setViewRegisterData(updatedData);
    // }
  };

  // const handleDateChange = (newDate) => {
  //   setPaymentDate(newDate);
  //   // setShowPaymentDateError(newDate != "" ? false : true);
  // };

  const handleRowInputClick = (index, currentDataIndex) => {
    // const updatedData = [...viewRegisterData];
    const updatedCurrentData = [...currentData];
    const currentIndex = toggleRowIndex % 3;

    // if (currentIndex === 0) {
    //   updatedData[index] = {
    //     ...updatedData[index],
    //     cr: "C",
    //   };
    // } else if (currentIndex === 1) {
    //   updatedData[index] = {
    //     ...updatedData[index],
    //     cr: "R",
    //   };
    // } else {
    //   updatedData[index] = {
    //     ...updatedData[index],
    //     cr: "",
    //   };
    // }

    if (currentIndex === 0) {
      updatedCurrentData[currentDataIndex] = {
        ...updatedCurrentData[currentDataIndex],
        cr: "C",
      };
    } else if (currentIndex === 1) {
      updatedCurrentData[currentDataIndex] = {
        ...updatedCurrentData[currentDataIndex],
        cr: "R",
      };
    } else {
      updatedCurrentData[currentDataIndex] = {
        ...updatedCurrentData[currentDataIndex],
        cr: "",
      };
    }

    console.log(updatedCurrentData[currentDataIndex], "checkcrdr 2");
    handleCRUpdateApi(
      updatedCurrentData[currentDataIndex]?.ID,
      updatedCurrentData[currentDataIndex]?.TransactionTypeID,
      updatedCurrentData[currentDataIndex]?.cr
    );

    setToggleRowIndex(currentIndex + 1);
    // setViewRegisterData(updatedData);
    setCurrentData(updatedCurrentData);
  };

  const handleCRUpdateApi = (ID, TransactionTypeID, cr) => {
    console.log(ID, TransactionTypeID, cr, "check data");
    let payloadData = {};
    payloadData = {
      txnid: ID,
      txntypeid: TransactionTypeID,
      loginuserid: loginuserid,
      cr: cr,
    };
    axios
      .post(
        `${config.accountingBaseUrl}/chartofaccounts/updatetransactioncr`,
        payloadData,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res data ==========>>>>", res);
        if (res.data.ResponseCode === "SUCCESS") {
          console.log("res data ==========>>>>", res);
          //  toastSuccess(SUCCESS_MESSAGE);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const Spilliting = (item) => {
    const items = item.split(",");
    // localStorage.setItem("Splits", JSON.stringify(items));
    setSplits(items);
  };

  //close
  const handleClose = () => {
    //setShowDeleteModal(false);
    setStateModal({ visible: null });
  };

  const handleCancelDelete = () => {
    //setShowDeleteModal(false);
    setStateModal({ visible: null });
  };

  // check Account Type is Payable/Receivable return true/ false
  const accountId = chartOfAccountDropdown?.some(
    (option) =>
      option.value == (paramObject?.id == undefined ? 0 : paramObject?.id) &&
      (option.AccountType === "Accounts Receivable" ||
        // option.AccountType === "Credit Card" ||
        option.AccountType === "Accounts Payable")
  );

  const isAccountPayable = chartOfAccountDropdown?.some(
    (option) =>
      option.value == (paramObject?.id == undefined ? 0 : paramObject?.id) &&
      option.AccountType === "Accounts Payable"
  );

  const isAccountsReceivable = chartOfAccountDropdown?.some(
    (option) =>
      option.value == (paramObject?.id == undefined ? 0 : paramObject?.id) &&
      option.AccountType === "Accounts Receivable"
  );

  // check Account Type is Credit Card return true/ false
  const isCreditCardAccount = chartOfAccountDropdown?.some(
    (option) =>
      option.value == (paramObject?.id == undefined ? 0 : paramObject?.id) &&
      option.AccountType === "Credit Card"
  );

  const isOtherCurrentAsset = chartOfAccountDropdown?.some(
    (option) =>
      option.value == (paramObject?.id == undefined ? 0 : paramObject?.id) &&
      (option.AccountType == "Other Current Asset" ||
        option.AccountType == "Other Current Liability" ||
        option.AccountType == "Long Term Liability" ||
        option.AccountType == "Equity" ||
        option.AccountType == "Fixed Asset")
  );

  const isBankAccount = chartOfAccountDropdown?.some(
    (option) =>
      option.value == (paramObject?.id == undefined ? 0 : paramObject?.id) &&
      option.AccountType == "Bank"
  );

  const isOtherCurrentAssetAccount = chartOfAccountDropdown?.some(
    (option) =>
      option.value == (paramObject?.id == undefined ? 0 : paramObject?.id) &&
      option.AccountType == "Other Current Asset"
  );

  console.log(chartOfAccountDropdown, "chartOfAccountDropdown");

  console.log(
    accountId,
    isCreditCardAccount,
    isOtherCurrentAsset,
    isAccountsReceivable,
    "isCreditCardAccount check"
  );

  const AddTransactionShowList = () => {
    // toastSuccess("AddTransactionShowList called");
    let showList = [];

    // Base: Remove "Vendor Credit" always
    showList = filteredTransactions.filter(
      (el) => el.label !== "Vendor Credit" && el.label !== "Bill" && el.label !== "Refund"
    );

    // Additional: If not credit card account, also remove "CC Credit"
    if (!isCreditCardAccount) {
      showList = showList.filter((el) => el.label !== "CC Credit");
    }

    // If it's Other Current Asset, remove additional types
    if (isOtherCurrentAsset) {
      const hiddenLabels = ["Expense", "CC Credit", "Check", "Bill Payments"];
      showList = showList.filter((el) => !hiddenLabels.includes(el.label));
    }

    // if (isOtherCurrentAsset) {
    //   const hiddenLabels = ["Expense", "CC Credit", "Check", "Bill Payments"];
    //   showList = showList.filter((el) => !hiddenLabels.includes(el.label));
    // }

    if (!(isOtherCurrentAssetAccount || isBankAccount)) {
      const hiddenLabels = ["Deposit"];
      showList = showList.filter((el) => !hiddenLabels.includes(el.label));
    }

    console.log(showList, isCreditCardAccount, "finalShowList");
    return showList;
  };

  const onRowEditTransaction = (rowID) => {
    let showList = [];

    if (rowID === 0) {
      // New Row: Always hide "Vendor Credit", conditionally hide "CC Credit"
      showList = filteredTransactions.filter((el) => {
        if (el.label === "Vendor Credit") return false;
        if (el.label === "Bill") return false;
        if (el.label === "Refund") return false;
        if (el.label === "CC Credit" && !isCreditCardAccount) return false;
        // Apply additional hiding for Other Current Asset
        if (isOtherCurrentAsset) {
          const hiddenLabels = [
            "Expense",
            "CC Credit",
            "Check",
            "Bill Payments",
            "Refund"
          ];
          if (hiddenLabels.includes(el.label)) return false;
        }

        if (!(isOtherCurrentAssetAccount || isBankAccount)) {
          const hiddenLabels = ["Deposit"];
          if (hiddenLabels.includes(el.label)) return false;
        }

        return true;
      });
    } else {
      // Edit Mode (rowID > 0): Show everything
      showList = filteredTransactions;
    }

    console.log(
      showList,
      rowID,
      isCreditCardAccount,
      "onRowEditTransaction showList"
    );
    return showList;
  };

  // console.log(
  //   chartOfAccountDetails?.AccountType,
  //   filteredTransactions,
  //   "filteredTransactions"
  // );

  // console.log(AddTransactionShowList(), "AddTransactionShowList");

  // const orderColumn = "desc";
  // const handelSortByAscDesc = (event) => {
  //   const columnName = event?.target?.id;
  //   // setShowSortData(true);
  //   console.log(columnName, "column name of click on tag");

  //   const sortOrder = orderColumn === "desc" ? "asc" : "desc";
  //   console.log("in function 145 rowsData before call");

  //   if (columnName === "Payment") {
  //     if (sortOrder === "asc") {
  //       setViewRegisterData(
  //         viewRegisterData
  //           .slice()
  //           .sort((a, b) => parseFloat(a.Payment) - parseFloat(b.Payment))
  //       );
  //     } else {
  //       setViewRegisterData(
  //         viewRegisterData
  //           .slice()
  //           .sort((a, b) => parseFloat(b.Payment) - parseFloat(a.Payment))
  //       );
  //     }
  //   } else if (columnName === "Balance") {
  //     if (sortOrder === "asc") {
  //       setViewRegisterData(
  //         viewRegisterData
  //           .slice()
  //           .sort((a, b) => parseFloat(a.Balance) - parseFloat(b.Balance))
  //       );
  //     } else {
  //       setViewRegisterData(
  //         viewRegisterData
  //           .slice()
  //           .sort((a, b) => parseFloat(b.Balance) - parseFloat(a.Balance))
  //       );
  //     }
  //   } else if (columnName === "Deposit") {
  //     if (sortOrder === "asc") {
  //       setViewRegisterData(
  //         viewRegisterData
  //           .slice()
  //           .sort((a, b) => parseFloat(a.Deposit) - parseFloat(b.Deposit))
  //       );
  //     } else {
  //       setViewRegisterData(
  //         viewRegisterData
  //           .slice()
  //           .sort((a, b) => parseFloat(b.Deposit) - parseFloat(a.Deposit))
  //       );
  //     }
  //   } else if (columnName === "Memo") {
  //     if (sortOrder === "asc") {
  //       setViewRegisterData(
  //         viewRegisterData.slice().sort((a, b) => {
  //           const memoA = a.Memo || ""; // Handle cases where Memo is null or undefined
  //           const memoB = b.Memo || "";

  //           return memoA.localeCompare(memoB);
  //         })
  //       );
  //     } else {
  //       setViewRegisterData(
  //         viewRegisterData.slice().sort((a, b) => {
  //           const memoA = a.Memo || ""; // Handle cases where Memo is null or undefined
  //           const memoB = b.Memo || "";

  //           return memoB.localeCompare(memoA);
  //         })
  //       );
  //     }
  //   } else if (columnName === "Payee") {
  //     if (sortOrder === "asc") {
  //       setViewRegisterData(
  //         viewRegisterData.slice().sort((a, b) => {
  //           const payeeA = a.Payee || ""; // Handle cases where Memo is null or undefined
  //           const payeeB = b.Payee || "";

  //           return payeeA.localeCompare(payeeB);
  //         })
  //       );
  //     } else {
  //       setViewRegisterData(
  //         viewRegisterData.slice().sort((a, b) => {
  //           const payeeA = a.Payee || ""; // Handle cases where Memo is null or undefined
  //           const payeeB = b.Payee || "";

  //           return payeeB.localeCompare(payeeA);
  //         })
  //       );
  //     }
  //   } else if (columnName === "AccountID") {
  //     sortOrder === "asc"
  //       ? setViewRegisterData(
  //           viewRegisterData.slice().sort((a, b) => a.AccountID - b.AccountID)
  //         )
  //       : setViewRegisterData(
  //           viewRegisterData.slice().sort((a, b) => b.AccountID - a.AccountID)
  //         );
  //   } else if (columnName === "Type") {
  //     sortOrder === "asc"
  //       ? setViewRegisterData(
  //           viewRegisterData
  //             .slice()
  //             .sort((a, b) => a.Type.localeCompare(b.Type))
  //         )
  //       : setViewRegisterData(
  //           viewRegisterData
  //             .slice()
  //             .sort((a, b) => b.Type.localeCompare(a.Type))
  //         );
  //   } else if (columnName === "Date") {
  //     sortOrder === "asc"
  //       ? setViewRegisterData(
  //           viewRegisterData
  //             .slice()
  //             .sort((a, b) => new Date(a.Date) - new Date(b.Date))
  //         )
  //       : setViewRegisterData(
  //           viewRegisterData
  //             .slice()
  //             .sort((a, b) => new Date(b.Date) - new Date(a.Date))
  //         );
  //   } else if (columnName === "RefNo") {
  //     sortOrder === "asc"
  //       ? setViewRegisterData(
  //           viewRegisterData
  //             .slice()
  //             .sort((a, b) => (a.RefNo || "").localeCompare(b.RefNo || ""))
  //         )
  //       : setViewRegisterData(
  //           viewRegisterData
  //             .slice()
  //             .sort((a, b) => (b.RefNo || "").localeCompare(a.RefNo || ""))
  //         );
  //   }
  //   console.log("column not matched");
  //   // setOrderColumn(sortOrder);
  //   // setRowsData(sortedArray);
  // };

  console.log(showNewRow, "showNewRow");

  const addNewRowForViewRegister = (label, value) => {
    if (!showNewRow) {
      const newRow = {
        RowNumber: 0,
        ID: 0,
        Date: moment().format("YYYY-MM-DD"),
        FromAccountID: paramObject?.id ?? 0,
        RefNo: "",
        Payee: "",
        Name: "",
        Memo: "",
        Account: 0,
        AccountName: "",
        Payment: "0",
        Deposit: "0",
        Module: "",
        PayeeId: 0,
        // PayeeUserType: getPayeeUserType(filteredTransactions),
        PayeeUserType:
          value == 6 ||
          value == 13 ||
          value == 14 ||
          value == 20 ||
          value == 21 ||
          value == 15 ||
          value == 12
            ? ""
            : value == 17 || value == 11 || value == 22
            ? "Customer"
            : "Supplier",
        // AccountID: paramObject?.id ?? 0,
        AccountID: 0,
        TransactionTypeID: value,
        Type: label,
        IsSplit: 0,
        SplitRecords: "",
        IsDefaultBalance: 0,
        AmountPaid: "",
        CreditNote: "",
        RecSaleID: 0,
        QuickbookId: 0,
        CreatedModifiedDate: "",
        cr: "",
        Deleted: 0,
        IsCustomerSplit: 0,
        DueDate: "",
        CreditUsed: "",
        ChartOfAccount: "",
        Balance: "",
        row_num: 0,
        showAll: false,
        categoryChartOfAccountId: 0,
      };

      // Update viewRegisterData
      setPageNum(1);
      setStartIndex(0);

      const updatedViewRegisterData = [newRow, ...currentData];
      console.log(updatedViewRegisterData, "updatedViewRegisterData");
      // Update currentData
      setExpandedRowId(0);
      setExpandedRowModule("");
      setTimeout(() => {
        setCurrentData(updatedViewRegisterData);
        // setExpandedRowId(0);
        setShowNewRow(true);
        setopendropdown(false);
        if (value == 15 || value == 7) {
          setIsCheckApiCall(true);
        }
      }, 300);
    }
  };

  const getPayeeUserType = (transactions) => {
    console.log(transactions, "transactionsshow");

    if (transactions?.length > 0) {
      const value = transactions[0]?.value;
      const customerValues = [17, 11, 22];
      const nonCustomerValues = [6, 13, 14, 20, 21, 15, 12];

      if (nonCustomerValues.includes(value)) return "";
      if (customerValues.includes(value)) return "Customer";
      return "Supplier";
    }
    return 0;
  };

  const reportPeriodAPI = () => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        let reportdropdown = [];
        const data2 = res.data.ResponseData?.map(
          (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
        );
        setSelectedDate(reportdropdown);
        return res;
      });
  };

  useEffect(() => {
    // AccountAPI();
    transactionType();
    payeeAPI();
    reportPeriodAPI();
  }, []);

  useEffect(() => {
    AccountAPI();
  }, [paramObject?.id]);

  // Inside your component:
  const debouncedSearchText = useDebounce(searchText, 500);

  useEffect(() => {
    if (paramObject?.id != undefined) {
      setSelectChartOfAccountId(paramObject?.id);
      setChartOfAccountDetails(
        chartOfAccountDropdown?.find((el) => el?.value == paramObject?.id)
      );
      setShowNewRow(false);
    }

    handleViewRegisterAPI(
      debouncedSearchText,
      selectTransactionType,
      customerId,
      supplierId,
      startdate,
      enddate,
      paramObject?.id, // account ID
      employeeId
    );
  }, [
    debouncedSearchText,
    selectTransactionType,
    customerId,
    supplierId,
    employeeId,
    startdate,
    enddate,
    paramObject?.id,
    pageSize,
    pageNum,
    sortConfig?.column,
    sortConfig?.order,
  ]);

  useEffect(() => {
    if (
      // (currentData[0]?.TransactionTypeID == 15 ||
      //   currentData[0]?.TransactionTypeID == 7) &&
      // paramObject?.id &&
      // showNewRow
      isCheckApiCall
    ) {
      // setTimeout(() => {
      latestCheckNumberAPI();
      //  }, 200);
    }
  }, [isCheckApiCall]);

  console.log(
    selectTransactionType,
    "selectTransactionType | ",
    customerId,
    "customerId | ",
    supplierId,
    "supplierId | ",
    employeeId,
    "employeeId | ",
    startdate,
    "startDate | ",
    enddate,
    "endDate | "
  );

  // const totalPages = Math.ceil(viewRegisterData?.length / ITEMS_PER_PAGE);

  // const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;

  // const currentData = viewRegisterData?.slice(
  //   startIndex,
  //   startIndex + ITEMS_PER_PAGE
  // );

  console.log(currentData, "viewRegisterData new");
  console.log(currentData[0], "mainData check");

  //   const totalPages = Math.ceil(viewRegisterData?.length / ITEMS_PER_PAGE);
  const totalPages = Math.ceil(totalRecords / ITEMS_PER_PAGE);

  const handlePageChange = (type) => {
    if (type == "first") {
      setPageNum(1);
    } else if (type == "last") {
      setPageNum(totalPages);
    } else if (type == "next") {
      setPageNum(Math.min(pageNum + 1, totalRecords));
    } else if (type == "previous") {
      setPageNum(Math.max(pageNum - 1, 1));
    } else {
      setPageNum(pageNum);
    }

    // setLoading(true);
    // setCurrentData([]);
    // let newPage;
    // switch (type) {
    //   case "first":
    //     newPage = 1;
    //     break;
    //   case "last":
    //     newPage = totalPages;
    //     break;
    //   case "next":
    //     newPage = Math.min(currentPage + 1, totalPages);
    //     break;
    //   case "previous":
    //     newPage = Math.max(currentPage - 1, 1);
    //     break;
    //   default:
    //     newPage = currentPage;
    // }

    // setCurrentPage(newPage);
    // const startIndexNo = (newPage - 1) * ITEMS_PER_PAGE;
    // setStartIndex(startIndexNo);
    // const newCurrentData = viewRegisterData.slice(
    //   startIndexNo,
    //   startIndexNo + ITEMS_PER_PAGE
    // );
    // setTimeout(() => {
    //   setCurrentData(newCurrentData);
    //   setLoading(false);
    // }, 500);
  };

  const dynamicPaymentLabel = isAccountPayable
    ? "Paid"
    : isOtherCurrentAsset
    ? "Decrease"
    : isCreditCardAccount || isAccountsReceivable
    ? "Payment"
    : "Payment";
  const dynamicDepositLabel = isAccountPayable
    ? "Billed"
    : isOtherCurrentAsset
    ? "Increase"
    : isCreditCardAccount
    ? "Charge"
    : isAccountsReceivable
    ? "Charge/Credit"
    : "Deposit";

  console.log(dynamicDepositLabel, "dynamicDepositLabel");

  const [columns, setColumns] = useState(() => {
    return [
      { id: "Date", label: "DATE", width: 100 },
      { id: "RefNo", label: "REF NO.", width: 100 },
      { id: "Type", label: "TYPE", width: 120 },
      { id: "Payee", label: "PAYEE", width: 140 },
      { id: "AccountID", label: "ACCOUNT", width: 140 },
      { id: "memo", label: "MEMO", width: 140 },
      // { id: "DueDate", label: "Due Date", width:0 },
      { id: "Payment", label: dynamicPaymentLabel, width: 100 },
      { id: "Deposit", label: dynamicDepositLabel, width: 100 },
      { id: "✔", label: "✔", width: 20 },
      { id: "Balance", label: "BALANCE", width: 100 },
    ];
  });

  useEffect(() => {
    // console.log(columns, "columns");
    const updatedColumns = columns
      .map((col) => {
        if (col.id === "Deposit") {
          return { ...col, label: dynamicDepositLabel };
        }
        if (col.id === "Payment") {
          return { ...col, label: dynamicPaymentLabel };
        }
        return col;
      })
      .filter((col) => col.id != "DueDate");
    // .filter((col) => {
    // if(accountId || isAccountsReceivable || isAccountPayable){
    //   return true
    // }else{
    //   if(col.id == "DueDate"){
    //     return false
    //         }else{
    //     return true
    //   }
    // }});
    if (accountId || isAccountsReceivable || isAccountPayable) {
      updatedColumns.push({ id: "DueDate", label: "Due Date", width: 150 });
    }
    setColumns(updatedColumns);
  }, [
    dynamicPaymentLabel,
    dynamicDepositLabel,
    accountId,
    isAccountsReceivable,
    isAccountPayable,
  ]);

  // useEffect(() => {
  //   const updatedColumns = columns;
  //   toastSuccess("update", isAccountsReceivable)
  //   setColumns(updatedColumns);
  // }, [isAccountPayable, isAccountsReceivable]);

  const tableRef = useRef(null);
  const startX = useRef(0);
  const startWidth = useRef(0);
  const resizingColumn = useRef(null);

  const handleMouseDown = (e, index) => {
    startX.current = e.clientX;
    startWidth.current = columns[index].width;
    resizingColumn.current = index;

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e) => {
    if (resizingColumn.current !== null) {
      const diff = e.clientX - startX.current;
      const newColumns = [...columns];
      newColumns[resizingColumn.current].width = Math.max(
        startWidth.current + diff,
        50 // Minimum column width
      );
      setColumns(newColumns);
    }
  };

  const handleMouseUp = () => {
    resizingColumn.current = null;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value === 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const handleCheckPermission = (type, field) => {
    if (field == "Save") {
      return (
        ((type === "Journal" || type === "Journal Entry" ) && checkUserPermission(ADDJOURNALS)) ||
        ((type === "Bill Payment" || type === "Bill Payments") && checkUserPermission(ADDPAYBILLS)) ||
        ((type === "Payment" || type === "Receive Payment") && checkUserPermission(ADDPAYMENTS)) ||
        (type === "Deposit" && checkUserPermission(ADDDEPOSITS)) ||
        ((type === "Bank Transfer" || type === "Transfer") &&
          checkUserPermission(ADDBANKTRANSFER)) ||
        ((type === "Expense" ||
          type === "Check" ||
          type === "CC Credit" ||
          type === "CC Expense") &&
          checkUserPermission(ADDEXPENSE)) 
          // || 
          // (type === "Refund" && true) || 
          // (type === "Sales Receipt" && true) 
      );
    } else if (field == "Edit") {
      return (
        ((type === "Journal" || type === "Journal Entry" ) && checkUserPermission(EDITJOURNALS)) ||
        ((type === "Bill Payment" || type === "Bill Payments") && checkUserPermission(EDITPAYBILLS)) ||
        ((type === "Payment" || type === "Receive Payment") && checkUserPermission(EDITPAYMENTS)) ||
        (type === "Deposit" && checkUserPermission(EDITDEPOSITS)) ||
        ((type === "Bank Transfer" || type === "Transfer") &&
          checkUserPermission(EDITBANKTRANSFER)) ||
        ((type === "Expense" ||
          type === "Check" ||
          type === "CC Credit" ||
          type === "CC Expense") &&
          checkUserPermission(EDITEXPENSE)) 
          // || 
          // (type === "Refund" && true) || 
          // (type === "Sales Receipt" && true) 
      );
    } else if (field == "Delete") {
      return (
        ((type === "Journal" || type === "Journal Entry" ) && checkUserPermission(DELETEJOURNALS)) ||
        ((type === "Bill Payment" || type === "Bill Payments") && checkUserPermission(DELETEPAYBILLS)) ||
        ((type === "Payment" || type === "Receive Payment") && checkUserPermission(DELETEPAYMENTS)) ||
        (type === "Deposit" && checkUserPermission(DELETEDEPOSITS)) ||
        ((type === "Bank Transfer" || type === "Transfer") &&
          checkUserPermission(DELETEBANKTRANSFER)) ||
        ((type === "Expense" ||
          type === "Check" ||
          type === "CC Credit" ||
          type === "CC Expense") &&
          checkUserPermission(DELETEEXPENSE)) 
          // || 
          // (type === "Refund" && true) || 
          // (type === "Sales Receipt" && true) 
      );
    }

    // If `field` is not handled, default to false
    return false;
  };

  console.table(columns, "columns check");

  useEffect(() => {
    document.body.classList.toggle("mini-sidebar");
  }, []);
  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* Page Header */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <div className="col"> */}
              {/* <h6 className="page-title">Accounting</h6> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/accounting">Account</Link>
                </li>
                <li className="breadcrumb-item active">View Register</li>
              </ul>
              {/* </div> */}
            </div>
          </div>
          {toggleItemsFilterSection ? (
            <>
              <div className="card">
                <div className="card-body">
                  <div className="col-lg-12 col-md-6 col-sm-12">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <div style={{ marginBottom: "10px" }}>
                          <div className="col-form-label">Find</div>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            id="find"
                            name="find"
                            value={searchText}
                            onChange={(event) =>
                              setSearchText(event?.target?.value)
                            }
                            placeholder="Search..."
                          />
                        </div>
                      </div>
                      {!accountId && (
                        <>
                          <div style={{ width: "16%" }}>
                            <div className="col-form-label">
                              Transaction Type
                            </div>
                            <Select
                              options={transactionTypeDropdown}
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              isClearable={true}
                              value={transactionTypeDropdown.find(
                                (option) =>
                                  option?.value == selectTransactionType
                              )}
                              onChange={(event) => {
                                setSelectTransactionType(
                                  event?.value ? event?.value : 1
                                );
                              }}
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              className="custom-search-select"
                            />
                          </div>
                          <div style={{ width: "20%" }}>
                            <div className="col-form-label">Payee </div>
                            <Select
                              options={payeePersonList}
                              onChange={(event) => {
                                console.log(event, "eventdata");
                                handlePayeeType(event);
                              }}
                              value={payeePersonList.find(
                                (item) => item.value == ""
                              )}
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              isClearable={true}
                              id="userid"
                              name="userid"
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              className="custom-search-select"
                            />
                          </div>
                        </>
                      )}
                      <div style={{ width: "17%" }}>
                        <label className="col-form-label col-md-12 form-label p-lg-medium">
                          Report period
                        </label>
                        <div className="row">
                          <div className="col-md-12 z-3">
                            <Select
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              options={selectedDate}
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              // isClearable={true}
                              name="Reportperiod"
                              id="Reportperiod"
                              value={selectedDate.find(
                                (e) => e.value === selectReport
                              )}
                              onChange={(event) => {
                                handleDropdownChange(event);
                              }}
                              className="custom-search-select"
                            ></Select>
                          </div>
                        </div>
                      </div>
                      {selectReport !== 1 && (
                        <div style={{ width: "24%" }}>
                          <ReportDate
                            callback={callback}
                            selectReport={selectReport}
                            showhidecomponent={
                              selectReport == 2 ||
                              selectReport == 3 ||
                              selectReport == 4 ||
                              selectReport == 5 ||
                              selectReport == 6 ||
                              selectReport == 7 ||
                              selectReport == 8 ||
                              selectReport == 9 ||
                              selectReport == 10 ||
                              selectReport == 11 ||
                              selectReport == 12 ||
                              selectReport == 13 ||
                              selectReport == 14 ||
                              selectReport == 15 ||
                              selectReport == 16 ||
                              selectReport == 17 ||
                              selectReport == 18 ||
                              selectReport == 19 ||
                              selectReport == 20 ||
                              selectReport == 21 ||
                              selectReport == 22 ||
                              selectReport == 23 ||
                              selectReport == 24 ||
                              selectReport == 25 ||
                              selectReport == 26 ||
                              selectReport == 27 ||
                              selectReport == 28 ||
                              selectReport == 29 ||
                              selectReport == 30 ||
                              selectReport == 31
                                ? true
                                : false
                            }
                          />
                        </div>
                      )}

                      {/* Date */}
                      {/* <div style={{ width: "17%" }}>
                        <div className="col-form-label"> Date </div>
                        <Select
                          onChange={(event) => {
                            handleDateFilter(event);
                          }}
                          options={dateOptions}
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                         
                          styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                          value={dateOptions.find(
                            (el) => el?.value == customeDate
                          )}
                          className="custom-search-select"
                        />
                      </div>
                      <div style={{ width: "12%" }}>
                        <div className="col-form-label">From</div>
                        <CommonDatePicker
                          FinalDate={beginningDate}
                          handleDateChange={handleDate}
                          showDefaultDate={
                            beginningDate && customeDate !== 0 ? true : false
                          }
                        />
                      </div>
                      <div style={{ width: "12%" }}>
                        <div className="col-form-label">To: </div>
                        <CommonDatePicker
                          FinalDate={finalDate}
                          handleDateChange={handleEndDate}
                          showDefaultDate={
                            finalDate && customeDate !== 0 ? true : false
                          }
                        />
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <></>
          )}

          <div className="card">
            <div className="card-body">
              {!QuickBookViewRagister && AllowQBSync && (
                <QuickbookSyncMessageComponent type="View Register Transactions" />
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "15px" }}
                >
                  <p style={{ fontSize: "20px" }}>Bank Register</p>
                  <div style={{ width: "350px" }}>
                    <Select
                      options={chartOfAccountDropdown}
                      onChange={(e) => handleAccountChange(e)}
                      value={chartOfAccountDropdown.find(
                        (option) => option?.value == selectChartOfAccountId
                      )}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      // hideSelectedOptions={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      id="AccountId"
                      name="AccountId"
                      className="custom-search-select"
                      formatOptionLabel={({
                        label,
                        parentName,
                        AccountType,
                      }) => (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <span>{label}</span>
                          <span
                            style={{
                              fontStyle: "italic",
                              color: "#666",
                              marginLeft: "1rem",
                            }}
                          >
                            {parentName
                              ? `Sub-account of ${parentName}`
                              : AccountType}
                          </span>
                        </div>
                      )}
                    />
                  </div>
                </div>

                <div style={{ textAlign: "right" }}>
                  <p style={{ margin: 0 }}>
                    <span style={{ fontSize: "20px" }}>Balance: </span>
                    <span style={{ fontWeight: "bold", fontSize: "20px" }}>
                      {CurrencySymbols(
                        Number(
                          [
                            "Accounts Payable (A/P) (Accounts Payable)",
                            "Accounts Receivable (A/R) (Accounts Receivable)",
                            "Opening Balance Equity (Equity)",
                            "Inventory Asset (Other Current Asset)",
                          ].includes(chartOfAccountDetails?.AccountFullName)
                            ? currentData[0]?.TotalBalance
                            : chartOfAccountDetails?.ParentAccountID > 0
                            ? chartOfAccountDetails?.ParentAmount
                            : chartOfAccountDetails?.amount
                        ),
                        CurrencySymbol,
                        FractionDigits
                      )}
                    </span>
                  </p>
                  <p style={{ margin: 0 }}>
                    <span style={{ fontSize: "12px" }}> Quickbook Balance: </span>
                    <span style={{ fontWeight: "bold", fontSize: "12px" }}>
                      {CurrencySymbols(
                        Number(
                          chartOfAccountDetails?.QBOpenBalance
                        ),
                        CurrencySymbol,
                        FractionDigits
                      )}
                    </span>
                  </p>
                </div>
              </div>

              <div
                className="d-flex justify-content-end align-items-center me-3 "
                style={{ marginTop: "5px" }}
              >
                <span
                  className="me-2 cursor-pointer"
                  onClick={() => handlePageChange("first")}
                  disabled={pageNum === 1}
                >
                  <u>First</u>
                </span>
                <span
                  className="me-2 cursor-pointer"
                  onClick={() => handlePageChange("previous")}
                  disabled={pageNum === 1}
                >
                  <u>Previous</u>
                </span>
                <span>
                  Page {pageNum} of {totalPages} (Total Records: {totalRecords}){" "}
                </span>
                <span
                  className="me-2 cursor-pointer"
                  onClick={() => handlePageChange("next")}
                  disabled={pageNum === totalPages}
                >
                  <u>Next</u>
                </span>
                <span
                  className="me-2 cursor-pointer"
                  onClick={() => handlePageChange("last")}
                  disabled={pageNum === totalPages}
                >
                  <u>Last</u>
                </span>
              </div>

              <div
                style={{
                  maxWidth: "100%",
                  padding: "10px",
                  overflow: "scroll",
                  overflowX: "auto",
                }}
              >
                {/* table */}
                <table
                  className="table custom-table"
                  ref={tableRef}
                  style={{
                    width: "100%",
                    textAlign: "center",
                    borderCollapse: "collapse",
                  }}
                >
                  <thead>
                    {SingleLine ? (
                      <>
                        <tr style={{ background: "var(--primary-color-10)" }}>
                          <td colSpan={accountId ? "11" : "10"}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              {/* Left-aligned paragraph */}
                              <p
                                style={{ fontSize: "15px" }}
                                className="col-md-6 text-start"
                                onClick={() =>
                                  setToggleItemsFilterSection(
                                    !toggleItemsFilterSection
                                  )
                                }
                              >
                                <>
                                  <i className="fa fa-filter"></i>
                                  All
                                </>
                              </p>

                              {/* Right-aligned dropdown */}
                              <div className="col-md-6 dropdown text-end">
                                <Link
                                  to="#"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <i className="fa fa-gear"></i>
                                </Link>
                                <div
                                  className="dropdown-menu p-3"
                                  style={{ width: "14rem" }}
                                >
                                  <div className="form-check mb-2">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="showInOneLine"
                                      onChange={(e) => handlesetsingleline(e)}
                                      checked={SingleLine}
                                    />
                                    <label htmlFor="showInOneLine">
                                      Show in one line
                                    </label>
                                  </div>
                                  <div className="form-check">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="paperLedgerMode"
                                      onChange={(e) =>
                                        handlesetPaperLedgerMode(e)
                                      }
                                      checked={PaperLedgerMode}
                                    />
                                    <label htmlFor="paperLedgerMode">
                                      Quickbook Layout
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>

                        <tr style={{ background: "var(--primary-base-color)" }}>
                          {columns.map((col, index) => (
                            <th
                              key={col.id}
                              style={{
                                width: `${col.width}px`,
                                position: "relative",
                                border: "1px solid #e9ecef",
                              }}
                              onClick={() => {
                                if (
                                  [
                                    "Date",
                                    "Type",
                                    "Payee",
                                    "memo",
                                    "DueDate",
                                    "✔",
                                  ].includes(col.id)
                                ) {
                                  handleSortstring(col.id);
                                } else {
                                  handleSort(col.id);
                                }
                              }}
                            >
                              {col.label}
                              <div
                                style={{
                                  position: "absolute",
                                  right: 0,
                                  top: 0,
                                  bottom: 0,
                                  width: "5px",
                                  cursor: "col-resize",
                                }}
                                onMouseDown={(e) => handleMouseDown(e, index)}
                              />
                              {sortConfig.column === `${col.id}`
                                ? sortConfig.order === "asc"
                                  ? "▲"
                                  : "▼"
                                : ""}
                            </th>
                          ))}
                        </tr>

                        <tr style={{ background: "var(--primary-color-10)" }}>
                          <td colSpan="1">
                            {!accountId && (
                              <div className=" col-ms-5  mr-2">
                                <div className="">
                                  <p
                                    onClick={() =>
                                      setopendropdown(!opendropdown)
                                    }
                                    //  onMouseEnter={() => setopendropdown(true)}
                                    style={{ fontSize: "15px" }}
                                  >
                                    Add ▼
                                  </p>
                                  {opendropdown ? (
                                    <div
                                      ref={searchResultRef}
                                      className=" transation "
                                    >
                                      {
                                        // filteredTransactions
                                        //   ?.filter(
                                        //     (el) => (el.label !== "Vendor Credit" && el.label !== "CC Credit")
                                        //   )
                                        AddTransactionShowList()?.map(
                                          (el, index) => (
                                            <div
                                              key={index}
                                              className="mb-2  hover-highlight pt-2 ps-3 pr-3"
                                            >
                                              <label
                                                onClick={() =>
                                                  addNewRowForViewRegister(
                                                    el.label,
                                                    el.value
                                                  )
                                                }
                                              >
                                                {el.label}
                                              </label>
                                            </div>
                                          )
                                        )
                                      }
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                            )}
                          </td>
                          <td colSpan={accountId ? "10" : "9"}></td>
                        </tr>
                      </>
                    ) : (
                      <>
                        <tr style={{ background: "#F0F4F6" }}>
                          <td colSpan="10">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              {/* Left-aligned paragraph */}
                              <p
                                style={{ fontSize: "15px" }}
                                className="col-md-6 text-start"
                                onClick={() =>
                                  setToggleItemsFilterSection(
                                    !toggleItemsFilterSection
                                  )
                                }
                              >
                                <>
                                  <i className="fa fa-filter"></i>
                                  All
                                </>
                              </p>

                              {/* Right-aligned dropdown */}
                              <div className="col-md-6 dropdown text-end">
                                <Link
                                  to="#"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <i className="fa fa-gear"></i>
                                </Link>
                                <div
                                  className="dropdown-menu p-3"
                                  style={{ width: "14rem" }}
                                >
                                  <div className="form-check mb-2">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="showInOneLine"
                                      onChange={(e) => handlesetsingleline(e)}
                                      checked={SingleLine}
                                    />
                                    <label htmlFor="showInOneLine">
                                      Show in one line
                                    </label>
                                  </div>
                                  <div className="form-check">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="paperLedgerMode"
                                      onChange={(e) =>
                                        handlesetPaperLedgerMode(e)
                                      }
                                      checked={PaperLedgerMode}
                                    />
                                    <label htmlFor="paperLedgerMode">
                                      Quickbook Layout
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th
                            onClick={() => handleSortstring("Date")}
                            className="borderleft"
                            style={{ width: "4rem" }}
                          >
                            DATE{" "}
                            {sortConfig.column === "Date"
                              ? sortConfig.order === "asc"
                                ? "▲"
                                : "▼"
                              : ""}
                          </th>

                          <th
                            className="borderleft"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleSort("RefNo")}
                          >
                            REF NO.{" "}
                            {sortConfig.column === "RefNo"
                              ? sortConfig.order === "asc"
                                ? "▲"
                                : "▼"
                              : ""}
                          </th>
                          <th
                            className="borderleft"
                            onClick={() => handleSortstring("Payee")}
                            style={{ width: "10rem", cursor: "pointer" }}
                          >
                            PAYEE{" "}
                            {sortConfig.column === "Payee"
                              ? sortConfig.order === "asc"
                                ? "▲"
                                : "▼"
                              : ""}
                          </th>
                          <th
                            className="borderleft"
                            name="Payment"
                            id="Payment"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleSort("Payment")}
                          >
                            {dynamicPaymentLabel}{" "}
                            {sortConfig.column === "Payment"
                              ? sortConfig.order === "asc"
                                ? "▲"
                                : "▼"
                              : ""}
                          </th>
                          <th
                            className="borderleft"
                            name="Deposit"
                            id="Deposit"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleSort("Deposit")}
                          >
                            {dynamicDepositLabel}{" "}
                            {sortConfig.column === "Deposit"
                              ? sortConfig.order === "asc"
                                ? "▲"
                                : "▼"
                              : ""}
                          </th>
                          <th
                            className="borderleft"
                            name="cr"
                            id="cr"
                            style={{ padding: "0px" }}
                            onClick={() => handleSortstring("cr")}
                          >
                            ✔
                            {sortConfig.column === "cr"
                              ? sortConfig.order === "asc"
                                ? "▲"
                                : "▼"
                              : ""}
                          </th>
                          <th
                            className="borderright"
                            name="Balance"
                            id="Balance"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleSort("Balance")}
                          >
                            BALANCE{" "}
                            {sortConfig.column === "Balance"
                              ? sortConfig.order === "asc"
                                ? "▲"
                                : "▼"
                              : ""}
                          </th>
                        </tr>
                        <tr>
                          <th className="borderleft"></th>
                          <th
                            className="borderleft"
                            name="Type"
                            id="Type"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleSortstring("Type")}
                          >
                            TYPE{" "}
                            {sortConfig.column === "Type"
                              ? sortConfig.order === "asc"
                                ? "▲"
                                : "▼"
                              : ""}
                          </th>
                          <th
                            className="borderleft"
                            name="AccountID"
                            id="AccountID"
                            style={{ width: "10rem", cursor: "pointer" }}
                            onClick={() => handleSort("AccountID")}
                          >
                            ACCOUNT{" "}
                            {sortConfig.column === "AccountID"
                              ? sortConfig.order === "asc"
                                ? "▲"
                                : "▼"
                              : ""}
                          </th>
                          <th
                            className="borderleft"
                            style={{ width: "10rem" }}
                          ></th>
                          <th className="borderleft">
                            {accountId ? "DueDate" : ""}
                          </th>
                          <th className="borderleft"></th>
                          <th
                            className="borderright"
                            style={{ width: "4rem" }}
                          ></th>
                        </tr>
                        <tr>
                          <th className="borderleft"></th>
                          <th className="borderleft"></th>
                          <th
                            className="borderleft"
                            name="Memo"
                            id="Memo"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleSortstring("memo")}
                          >
                            MEMO{" "}
                            {sortConfig.column === "memo"
                              ? sortConfig.order === "asc"
                                ? "▲"
                                : "▼"
                              : ""}
                          </th>
                          <th
                            className="borderleft"
                            style={{ width: "10rem" }}
                          ></th>
                          <th className="borderleft"></th>
                          <th className="borderleft"></th>
                          <th
                            className="borderright"
                            style={{ width: "4rem" }}
                          ></th>
                        </tr>
                        <tr style={{ background: "#F0F4F6" }}>
                          <td colSpan="1">
                            <>
                              {!accountId && (
                                <div className=" col-ms-5  mr-2">
                                  <div>
                                    <p
                                      onClick={() =>
                                        setopendropdown(!opendropdown)
                                      }
                                      // onMouseEnter={() => setopendropdown(true)}
                                      style={{ fontSize: "15px" }}
                                    >
                                      Add ▼
                                    </p>
                                    {opendropdown ? (
                                      <div
                                        ref={searchResultRef}
                                        className=" transation "
                                      >
                                        {AddTransactionShowList()?.map(
                                          (el, index) => (
                                            <div
                                              key={index}
                                              className="hover-highlight pt-2 ps-3 pr-3"
                                            >
                                              <label
                                                onClick={() =>
                                                  addNewRowForViewRegister(
                                                    el.label,
                                                    el.value
                                                  )
                                                }
                                              >
                                                {el.label}
                                              </label>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </div>
                              )}
                            </>
                          </td>
                          <td colSpan="9"></td>
                        </tr>
                      </>
                    )}
                  </thead>

                  <tbody>
                    {/* {viewRegisterData?.map((item, index) => { */}
                    {SingleLine
                      ? currentData?.map((item, index) =>
                          expandedRowId === item?.ID &&
                          expandedRowModule === item.Module ? (
                            <>
                              <tr
                                style={{
                                  borderBottom:
                                    "1px solid var(--primary-color-50)",
                                  marginBottom: "10px",
                                  background: "#F0F4F6",
                                }}
                                key={index}
                              >
                                <td
                                  style={{ width: `${columns[0].width}px` }}
                                  className="d-flex align-items-center gap-1 mt-3"
                                >
                                  {item?.TransactionTypeID == 23 ||
                                  item?.TransactionTypeID == 24 ? (
                                    ""
                                  ) : (
                                    <span
                                      title={
                                        item?.SyncStatus > 0
                                          ? "Synced"
                                          : item?.QuickbookFailureReason
                                      }
                                    >
                                      <i
                                        className={`fa fa-circle ${
                                          item?.SyncStatus > 0
                                            ? "text-success"
                                            : "text-danger"
                                        }`}
                                      ></i>
                                    </span>
                                  )}
                                  <div
                                    style={{ padding: "0px", width: "70px" }}
                                  >
                                    <CommonDatePicker
                                      FinalDate={item?.Date}
                                      handleDateChange={(event) =>
                                        handleInputChange(
                                          event,
                                          startIndex + index,
                                          "Date",
                                          index
                                        )
                                      }
                                      disabled={
                                        item?.TransactionTypeID == 3 ||
                                        item?.TransactionTypeID == 23 ||
                                        accountId
                                      }
                                      from="Vregister"
                                    />
                                  </div>
                                </td>
                                <td
                                  style={{
                                    padding: "0px",
                                    width: `${columns[0].width}px`,
                                  }}
                                >
                                  <input
                                    className="col-md-12 custom-form-control-sm-font"
                                    type="text"
                                    id="refno"
                                    name="refno"
                                    placeholder="Reference No."
                                    style={
                                      {
                                        // ...inputStyles,
                                        // backgroundColor:
                                        //   item?.TransactionTypeID === 12 ||
                                        //   item?.TransactionTypeID === 13
                                        //     ? "dark"
                                        //     : "",
                                        // width: "80px",
                                        // fontSize: "12px",
                                        // height:"32px"
                                      }
                                    }
                                    onChange={(event) =>
                                      handleInputChange(
                                        event?.target?.value,
                                        startIndex + index,
                                        "RefNo",
                                        index
                                      )
                                    }
                                    value={item?.RefNo}
                                    disabled={
                                      showNewRow
                                        ? item?.TransactionTypeID == 12 ||
                                          item?.TransactionTypeID == 13
                                          ? true
                                          : false
                                        : item?.TransactionTypeID == 12 ||
                                          item?.TransactionTypeID == 13 ||
                                          item?.TransactionTypeID == 3 ||
                                          item?.TransactionTypeID == 23 ||
                                          item?.TransactionTypeID == 5 ||
                                          item?.RefNo == "To Print" ||
                                          (item?.TransactionTypeID == 6 &&
                                            item?.IsOppositeEntry == 1) ||
                                          accountId
                                        ? // item?.TransactionTypeID == 8 ||
                                          // item?.TransactionTypeID == 9
                                          // item?.TransactionTypeID == 6 ||
                                          true
                                        : false
                                    }
                                  />
                                </td>

                                <td
                                  style={{
                                    padding: "0px",
                                    width: `${columns[0].width}px`,
                                  }}
                                >
                                  {/* {"T: " + item?.TransactionTypeID} */}
                                  <div
                                    style={{
                                      height: "30px",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    <Select
                                      options={onRowEditTransaction(item.ID)}
                                      value={filteredTransactions?.find(
                                        (option) =>
                                          option?.value ==
                                          item?.TransactionTypeID
                                      )}
                                      onChange={(event) =>
                                        handleInputChange(
                                          event,
                                          startIndex + index,
                                          "Type",
                                          index
                                        )
                                      }
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      styles={
                                        CUSTOM_SELECT_DROPDOWN_STYLE_VIEW_VREGISTER
                                      }
                                      className="custom-hight-dropdown custom-search-select col-md-11 "
                                      placeholder="Type"
                                      id="Type"
                                      name="Type"
                                      isDisabled={
                                        item?.ID > 0 || accountId ? true : false
                                      } // 11,
                                      // isOptionDisabled={true}
                                    />
                                  </div>
                                </td>

                                <td
                                  style={{
                                    padding: "0px",
                                    width: `${columns[0].width}px`,
                                  }}
                                >
                                  <div style={{}}>
                                    {item.IsCustomerSplit == 1 ? (
                                      <>
                                        <button
                                          className="btn btn-sm btn-outline-primary btn-custom-padding col-md-11  mt-2 ml-2"
                                          data-toggle="tooltip"
                                          data-placement="bottom"
                                          data-bs-toggle="modal"
                                          data-bs-target="#SplittingConfirmationModal"
                                          onClick={() =>
                                            Spilliting(item?.SplitRecords)
                                          }
                                        >
                                          -Split-
                                        </button>
                                      </>
                                    ) : (
                                      <Select
                                        onChange={(event) =>
                                          handleInputChange(
                                            event,
                                            startIndex + index,
                                            "PayeeId",
                                            index
                                          )
                                        }
                                        options={
                                          (item?.TransactionTypeID == 6 ||
                                            item?.TransactionTypeID == 12) &&
                                          accountDropdown.some(
                                            (acc) =>
                                              acc.value == item?.AccountID &&
                                              (acc.AccountFullName ===
                                                "Accounts Receivable (A/R) (Accounts Receivable)" ||
                                                acc.AccountFullName ===
                                                  "Accounts Payable (A/P) (Accounts Payable)")
                                          )
                                            ? payeePersonList?.filter((el) => {
                                                const account =
                                                  accountDropdown.find(
                                                    (acc) =>
                                                      acc.value ===
                                                      item?.AccountID
                                                  );
                                                if (
                                                  account?.AccountFullName.includes(
                                                    "Accounts Receivable (A/R) (Accounts Receivable)"
                                                  )
                                                ) {
                                                  return (
                                                    el?.UserType === "Customer"
                                                  );
                                                } else if (
                                                  account?.AccountFullName.includes(
                                                    "Accounts Payable (A/P) (Accounts Payable)"
                                                  )
                                                ) {
                                                  return (
                                                    el?.UserType === "Supplier"
                                                  );
                                                }
                                              })
                                            : item?.TransactionTypeID == 6 ||
                                              item?.TransactionTypeID == 13 ||
                                              item?.TransactionTypeID == 14 ||
                                              item?.TransactionTypeID == 20 ||
                                              item?.TransactionTypeID == 21 ||
                                              item?.TransactionTypeID == 15 ||
                                              item?.TransactionTypeID == 12
                                            ? // item?.TransactionTypeID == 11
                                              payeePersonList
                                            : payeePersonList?.filter(
                                                (el) =>
                                                  el?.UserType ===
                                                  item?.PayeeUserType
                                              )
                                        }
                                        backspaceRemovesValue={false}
                                        controlShouldRenderValue={true}
                                        // isClearable={
                                        //   item?.TransactionTypeID == 6
                                        //     ? true
                                        //     : false
                                        // }
                                        value={
                                          item?.PayeeId == 0
                                            ? null
                                            : payeePersonList
                                                ?.filter(
                                                  (el) =>
                                                    el?.UserType ===
                                                    item?.PayeeUserType
                                                )
                                                ?.find(
                                                  (option) =>
                                                    option?.value ==
                                                    item?.PayeeId
                                                )
                                        }
                                        styles={
                                          CUSTOM_SELECT_DROPDOWN_STYLE_VIEW_VREGISTER
                                        }
                                        placeholder={"Payee"}
                                        id="Payee"
                                        name="Payee"
                                        className="custom-search-select col-md-11 "
                                        isDisabled={
                                          // showNewRow
                                          //   ? item?.TransactionTypeID == 13
                                          //     ? true
                                          //     : false
                                          // :

                                          // item?.TransactionTypeID == 12 ||
                                          // item?.TransactionTypeID == 11 ||
                                          item?.IsPaid > 0 || accountId
                                            ? // item?.TransactionTypeID == 7 //||
                                              // item?.TransactionTypeID == 13
                                              true
                                            : false
                                        }
                                      />
                                    )}
                                  </div>
                                </td>

                                <td
                                  style={{
                                    padding: "0px",
                                    width: `${columns[0].width}px`,
                                  }}
                                >
                                  <div style={{}}>
                                    {item.IsSplit == 1 ? (
                                      <>
                                        <button
                                          className="border-0 btn btn-sm btn-outline-primary btn-custom-padding col-md-12"
                                          data-toggle="tooltip"
                                          data-placement="bottom"
                                          data-bs-toggle="modal"
                                          data-bs-target="#SplittingConfirmationModal"
                                          onClick={() =>
                                            Spilliting(item?.SplitRecords)
                                          }
                                          style={{
                                            height: "32px",
                                            backgroundColor: "transparent",
                                            borderBottom: "2px solid ",
                                            fontWeight: "600",
                                          }}
                                        >
                                          -Split-
                                        </button>
                                      </>
                                    ) : (
                                      <Select
                                        onChange={(event) =>
                                          handleInputChange(
                                            event,
                                            startIndex + index,
                                            "AccountID",
                                            index
                                          )
                                        }
                                        value={
                                          accountDropdown.find(
                                            (option) =>
                                              option?.value == item?.AccountID
                                          ) || null
                                        }
                                        placeholder={"Account"}
                                        options={accountDropdown}
                                        backspaceRemovesValue={false}
                                        controlShouldRenderValue={true}
                                        hideSelectedOptions={true}
                                        isClearable={false}
                                        styles={
                                          CUSTOM_SELECT_DROPDOWN_STYLE_VIEW_VREGISTER
                                        }
                                        id="AccountId"
                                        name="AccountId"
                                        isDisabled={
                                          showNewRow && index === 0
                                            ? item?.TransactionTypeID == 7 ||
                                              item?.TransactionTypeID == 11 ||
                                              item?.TransactionTypeID == 17 ||
                                              item?.TransactionTypeID == 22
                                              ? true
                                              : false
                                            : item?.TransactionTypeID == 3 || // bill
                                              item?.TransactionTypeID == 5 || // vendor credit
                                              item?.TransactionTypeID == 23 || // Inventory Starting value
                                              item?.IsPaid > 0 ||
                                              accountId ||
                                              (item.IsOppositeEntry == 1 &&
                                                item?.TransactionTypeID !=
                                                  13) ||
                                              (item?.TransactionTypeID != 13 &&
                                                item?.FromAccountID !=
                                                  selectChartOfAccountId)
                                          // item?.TransactionTypeID == 11 ||
                                          //   (item?.TransactionTypeID == 6 &&
                                          //     item?.IsOppositeEntry == 1) ||
                                          //   item?.TransactionTypeID == 7 ||
                                          //   item?.TransactionTypeID == 17 ||
                                          //   item?.TransactionTypeID == 22 ||
                                          //   (item?.TransactionTypeID == 15 && (chartOfAccountId === 4 || chartOfAccountId === 2) ? Number(item?.Payment || 0) == 0 : Number(item?.Deposit || 0) == 0) ||
                                          //   (item?.TransactionTypeID == 12 &&
                                          //     item?.ChartOfAccount ===
                                          //       "Undeposited Funds" &&
                                          //     item?.IsSplit == 0) ||
                                          //   (item?.TransactionTypeID == 12 &&
                                          //     item?.Memo ===
                                          //       "Opening Balance") ||
                                          //   (item?.TransactionTypeID == 12 &&
                                          //     item?.IsOppositeEntry == 1) ||
                                          //   (item?.TransactionTypeID == 14 &&
                                          //     item?.IsSplit == 1) // ||
                                          // ? // item?.TransactionTypeID == 9 ||
                                          //   // item?.IsDefaultBalance == 1
                                          //   true
                                          // : false
                                        }
                                        className="custom-search-select  col-md-12"
                                        formatOptionLabel={({
                                          label,
                                          parentName,
                                          AccountType,
                                        }) => (
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <span>{label}</span>
                                            <span
                                              style={{
                                                fontStyle: "italic",
                                                color: "#666",
                                                marginLeft: "1rem",
                                              }}
                                            >
                                              {parentName
                                                ? `Sub-account of ${parentName}`
                                                : AccountType}
                                            </span>
                                          </div>
                                        )}
                                      />
                                    )}
                                  </div>
                                </td>

                                <td style={{ width: `${columns[0].width}px` }}>
                                  <input
                                    className="custom-radius-border form-control form-control-sm mt-3 col-md-12 mb-3"
                                    type="text"
                                    style={{ fontSize: "12px", height: "30px" }}
                                    placeholder="Memo"
                                    onChange={(event) =>
                                      handleInputChange(
                                        event,
                                        startIndex + index,
                                        "Memo",
                                        index
                                      )
                                    }
                                    value={item?.Memo}
                                    disabled={
                                      item?.IsDefaultBalance == 1 ||
                                      accountId ||
                                      item?.TransactionTypeID == 23
                                      // showNewRow
                                      //   ? false
                                      //   : item?.IsDefaultBalance == 1
                                      //   ? true
                                      //   : false
                                    }
                                  />
                                </td>

                                <td
                                  style={{
                                    padding: "0px",
                                    width: `${columns[0].width}px`,
                                  }}
                                >
                                  <input
                                    className="custom-radius-border form-control form-control-sm custom-hight-dropdown"
                                    type="text"
                                    style={{ fontSize: "12px" }}
                                    // style={inputStyles}
                                    value={` ${CurrencySymbol}${item?.Payment}`}
                                    onFocus={(e) => e.target.select()}
                                    placeholder="Payment"
                                    onChange={(event) => {
                                      let inputValue = event.target.value;
                                      inputValue = inputValue.replace(
                                        /[^\d.]/g,
                                        ""
                                      );

                                      if (
                                        inputValue &&
                                        !inputValue.startsWith(CurrencySymbol)
                                      ) {
                                        inputValue = `${inputValue}`;
                                      }

                                      event.target.value = inputValue;

                                      handleInputChange(
                                        event,
                                        startIndex + index,
                                        "Payment",
                                        index
                                      );
                                    }}
                                    disabled={
                                      showNewRow && index === 0
                                        ? (chartOfAccountId != 2 &&
                                            chartOfAccountId != 4 &&
                                            item?.TransactionTypeID == 6) || // expense
                                          (chartOfAccountId != 2 &&
                                            chartOfAccountId != 4 &&
                                            item?.TransactionTypeID == 7) || // expense
                                          item?.TransactionTypeID == 11 ||
                                          item?.TransactionTypeID == 17 ||
                                          item?.TransactionTypeID == 23 ||
                                          item?.TransactionTypeID == 20 || // CC Expense
                                          item?.TransactionTypeID == 12 // ||
                                          ? true
                                          : false
                                        : item?.isPayment == 0 ||
                                          item?.IsPaid > 0 ||
                                          accountId ||
                                          item?.IsSplit == 1
                                        ? true
                                        : false
                                    }
                                  />
                                  {showNewRow &&
                                    BillInvoice > 0 &&
                                    (() => {
                                      const selectedInvoice =
                                        pendinginvoice?.find(
                                          (el) => el?.value == BillInvoice
                                        );
                                      console.log(
                                        selectedInvoice,
                                        "selectedInvoice"
                                      );

                                      return selectedInvoice ? (
                                        <div style={{ fontSize: "0.875rem" }}>
                                          {item?.TransactionTypeID === 7
                                            ? "Bill Amt.:"
                                            : "Inv Amt:"}{" "}
                                          {CurrencySymbols(
                                            Number(
                                              selectedInvoice.txnTotal
                                            ).toFixed(2),
                                            CurrencySymbol,
                                            FractionDigits
                                          )}
                                        </div>
                                      ) : null;
                                    })()}
                                </td>

                                <td style={{ width: `${columns[0].width}px` }}>
                                  {/* {"T: " + item?.TransactionTypeID} */}
                                  <input
                                    className="form-control form-control-sm custom-form-control-sm-font"
                                    type="text"
                                    style={{ fontSize: "12px" }}
                                    // style={inputStyles}
                                    placeholder="Deposit"
                                    onFocus={(e) => e.target.select()}
                                    value={`${CurrencySymbol}${item?.Deposit}`}
                                    onChange={(event) => {
                                      let inputValue = event.target.value;

                                      inputValue = inputValue.replace(
                                        /[^\d.]/g,
                                        ""
                                      );

                                      if (
                                        inputValue &&
                                        !inputValue.startsWith(CurrencySymbol)
                                      ) {
                                        inputValue = `${inputValue}`;
                                      }

                                      event.target.value = inputValue;

                                      handleInputChange(
                                        event,
                                        startIndex + index,
                                        "Deposit",
                                        index
                                      );
                                    }}
                                    disabled={
                                      showNewRow && index === 0
                                        ? item?.TransactionTypeID == 21 || // cc credit
                                          ((chartOfAccountId == 2 ||
                                            chartOfAccountId == 4) &&
                                            item?.TransactionTypeID == 6) ||
                                          ((chartOfAccountId == 2 ||
                                            chartOfAccountId == 4) &&
                                            item?.TransactionTypeID == 7)
                                          ? // item?.TransactionTypeID == 6
                                            // || item?.TransactionTypeID == 20
                                            true
                                          : false
                                        : item?.isDeposit == 0 ||
                                          item?.IsPaid > 0 ||
                                          accountId ||
                                          item?.TransactionTypeID == 23 ||
                                          item?.IsSplit == 1
                                        ? true
                                        : false
                                      // (item?.TransactionTypeID == 13 &&
                                      //     item?.Deposit == 0) ||
                                      //   item?.IsSplit == 1 ||
                                      //   item?.TransactionTypeID == 14 ||
                                      //   item?.TransactionTypeID == 21 ||
                                      //   // item?.TransactionTypeID == 15 ||
                                      //   (item?.TransactionTypeID == 15 && Number(item?.Deposit || 0) == 0) ||
                                      //   item?.TransactionTypeID == 17 ||
                                      //   (chartOfAccountId == 2 || chartOfAccountId == 4) && item?.TransactionTypeID == 6 ||
                                      //   // item?.TransactionTypeID == 21 ||
                                      //   // item?.TransactionTypeID == 6 ||
                                      //   // (item?.TransactionTypeID == 6 &&
                                      //   //   item?.IsOppositeEntry == 0) ||
                                      //   item?.TransactionTypeID == 7 ||
                                      //   (item?.TransactionTypeID == 12 &&
                                      //     item?.ChartOfAccount ===
                                      //       "Undeposited Funds" &&
                                      //     item?.IsSplit == 0) ||
                                      //   (item?.TransactionTypeID == 12 &&
                                      //     item?.Memo === "Opening Balance") ||
                                      //   (item?.TransactionTypeID == 12 &&
                                      //     item?.IsOppositeEntry == 1) ||
                                      //   item?.TransactionTypeID == 11 // ||
                                      // ? // item?.TransactionTypeID == 6 ||
                                      //   // item?.TransactionTypeID == 13 ||
                                      //   // item?.IsDefaultBalance == 1 ||

                                      //   true
                                      // : false
                                    }
                                  />
                                  {showNewRow &&
                                    BillInvoice > 0 &&
                                    (() => {
                                      const selectedInvoice =
                                        pendinginvoice?.find(
                                          (el) => el?.value == BillInvoice
                                        );
                                      console.log(
                                        selectedInvoice,
                                        "selectedInvoice"
                                      );

                                      return selectedInvoice ? (
                                        <div style={{ fontSize: "0.875rem" }}>
                                          Open Bal.:{" "}
                                          {CurrencySymbols(
                                            Number(
                                              selectedInvoice.total
                                            ).toFixed(2),
                                            CurrencySymbol,
                                            FractionDigits
                                          )}
                                        </div>
                                      ) : null;
                                    })()}
                                </td>
                                <td style={{ width: `${columns[0].width}px` }}>
                                  <input
                                    value={currentData[startIndex + index]?.cr}
                                    className="custom-radius-border form-control form-control-sm"
                                    type="text"
                                    style={{
                                      width: "40px",
                                      height: "30px",
                                    }}
                                    onClick={() =>
                                      handleRowInputClick(
                                        startIndex + index,
                                        index
                                      )
                                    }
                                    onChange={(event) => event}
                                    disabled={
                                      accountId || item?.TransactionTypeID == 23
                                        ? true
                                        : false
                                      // item?.IsDefaultBalance == 1
                                      //   ? true
                                      //   : false
                                    }
                                    // readOnly
                                  />
                                </td>
                                <td style={{ width: `${columns[0].width}px` }}>
                                  {item?.Balance < 0 ? (
                                    <p
                                      className="mb-2 font-bold"
                                      style={{
                                        color: "var(--error-main-color)",
                                      }}
                                    >
                                      {CurrencySymbols(
                                        Number(item.Balance).toFixed(2),
                                        CurrencySymbol,
                                        FractionDigits
                                      )}
                                    </p>
                                  ) : selectTransactionType === 1 ||
                                    selectTransactionType === undefined ? (
                                    <p
                                      className="mb-2 font-bold"
                                      style={{
                                        color: "var(--success-main-color)",
                                      }}
                                    >
                                      {CurrencySymbols(
                                        Number(item.Balance).toFixed(2),
                                        CurrencySymbol,
                                        FractionDigits
                                      )}
                                    </p>
                                  ) : startIndex + index === 0 ? (
                                    <>
                                      <p>(Only displayed with</p>
                                      <p>date/reconcile </p>
                                      <p>status sort)</p>
                                    </>
                                  ) : (
                                    "n/a"
                                  )}
                                </td>
                              </tr>
                              <tr style={{ background: "#F0F4F6" }}>
                                <td></td>
                                <td></td>

                                <td> </td>
                                <td></td>
                                <td></td>
                                <td colSpan={showNewRow ? 2 : 1}>
                                  {showNewRow &&
                                  (item?.TransactionTypeID == 7 ||
                                    item?.TransactionTypeID == 11) ? (
                                    <>
                                      <Select
                                        onChange={(event) =>
                                          handleInputChange(
                                            event,
                                            startIndex + index,
                                            "BillInvoice",
                                            index
                                          )
                                        }
                                        value={
                                          billInvoiceSelect
                                            ? pendinginvoice?.find(
                                                (el) =>
                                                  el?.value == billInvoiceSelect
                                              )
                                            : null
                                        }
                                        options={pendinginvoice}
                                        backspaceRemovesValue={false}
                                        controlShouldRenderValue={true}
                                        hideSelectedOptions={true}
                                        styles={selectDropdownStyles}
                                        className="col-md-11 mt-3 custom-search-select"
                                        placeholder={
                                          item?.TransactionTypeID == 7
                                            ? "Bill No."
                                            : item?.TransactionTypeID == 11
                                            ? "Invoice No"
                                            : ""
                                        }
                                        id="BillInvoice"
                                        name="BillInvoice"
                                      />
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                {showNewRow ? (
                                  <>
                                    <td></td>
                                    <td></td>
                                  </>
                                ) : (
                                  <></>
                                )}

                                <td colSpan={showNewRow ? 2 : 4}>
                                  <>
                                    {(showNewRow && index === 0) ||
                                    item?.Deleted === 1 ||
                                    item?.TransactionTypeID == 23 ||
                                    !handleCheckPermission(
                                      item?.Type,
                                      "Delete"
                                    ) ? (
                                      // 23 Inventory starting value
                                      ""
                                    ) : item?.IsDefaultBalance != 1 ? (
                                      <>
                                        {item.IsDefaultBalance == 0 && (
                                          <>
                                            <button
                                              type="button"
                                              class="btn btn-secondary btn-sm"
                                              style={{ marginRight: "10px" }}
                                              onClick={() =>
                                                handleDeleteClick(
                                                  item,
                                                  startIndex + index
                                                )
                                              }
                                            >
                                              Delete
                                            </button>
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                    <div
                                      className={`modal ${
                                        stateModal.visible ===
                                        startIndex + index
                                          ? "d-block"
                                          : ""
                                      }`}
                                      tabIndex="-1"
                                      style={{ background: "rgba(0,0,0,0.2)" }}
                                    >
                                      <div className="modal-dialog modal-sm modal-dialog-centered">
                                        <div className="modal-content">
                                          <div className="modal-header">
                                            <h5 className="title-model">
                                              Confirmation
                                            </h5>
                                            <button
                                              type="button"
                                              className="btn-close"
                                              data-bs-dismiss="modal"
                                              aria-label="Close"
                                              onClick={handleClose}
                                            >
                                              <span aria-hidden="true">×</span>
                                            </button>
                                          </div>
                                          <div className="modal-body">
                                            <div className="row">
                                              <div className="col-lg-12">
                                                <p className="mb-2">
                                                  Are you sure you want to
                                                  delete this row?
                                                </p>
                                                {false && (
                                                  <>
                                                    <p className=" text-danger">
                                                      Note: Credit delete need
                                                      to deleted manually
                                                    </p>
                                                    <p className=" text-danger">
                                                      from the QuickBook because
                                                      it won't SYNC.
                                                    </p>
                                                  </>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="modal-footer justify-content-center">
                                            <button
                                              type="button"
                                              className="btn btn-primary"
                                              onClick={() =>
                                                handleConfirmDelete()
                                              }
                                              checkafter
                                            >
                                              Delete
                                            </button>
                                            <button
                                              type="button"
                                              className="btn btn-secondary"
                                              onClick={handleCancelDelete}
                                            >
                                              Cancel
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {showNewRow ? (
                                      ""
                                    ) : item?.Type == "Opening Balance" ||
                                      item?.Deleted == 1 ||
                                      !handleCheckPermission(
                                        item?.Type,
                                        "Edit"
                                      ) ? (
                                      ""
                                    ) : (
                                      <button
                                        type="button"
                                        class="btn btn-secondary btn-sm"
                                        style={{ marginRight: "10px" }}
                                        onClick={() =>
                                          handleEdit(
                                            item?.TransactionTypeID,
                                            item?.TransactionTypeID == 23
                                              ? item?.ItemsId
                                              : item?.ID, // 23 Inventory starting value
                                            item?.Type,
                                            item?.RecSaleIDc
                                          )
                                        }
                                      >
                                        Edit
                                      </button>
                                    )}
                                    <button
                                      type="button"
                                      class="btn btn-secondary btn-sm"
                                      onClick={() =>
                                        handleRowClick(item?.ID, item?.Module)
                                      }
                                      style={{ marginRight: "10px" }}
                                    >
                                      {" "}
                                      cancel
                                    </button>
                                    {item?.Type === "Opening Balance" ||
                                    item?.Deleted === 1 ||
                                    item?.TransactionTypeID == 23 ||
                                    !handleCheckPermission(
                                      item?.Type,
                                      "Save"
                                    ) ? (
                                      ""
                                    ) : (
                                      <button
                                        type="button"
                                        class="btn btn-primary btn-sm  "
                                        onClick={() =>
                                          // showNewRow
                                          item?.ID == 0
                                            ? handleSubmit("add")
                                            : handleSubmit(
                                                "edit",
                                                startIndex + index,
                                                item.IsSplit,
                                                index
                                              )
                                        }
                                        style={{ marginRight: "10px" }}
                                      >
                                        Save
                                      </button>
                                    )}{" "}
                                  </>
                                </td>
                              </tr>
                            </>
                          ) : (
                            <>
                              <tr
                                key={index}
                                style={{
                                  cursor: "pointer",
                                  backgroundColor:
                                    index % 2 === 0
                                      ? "var(--primary-color-10)"
                                      : "var(--primary-base-color)",
                                  height: "38px",
                                }}
                                className="borderbottom"
                              >
                                <td
                                  onClick={() => {
                                    if (
                                      !accountId &&
                                      item?.TransactionTypeID != 23 &&
                                      item?.TransactionTypeID != 24
                                    ) {
                                      handleRowClick(item?.ID, item?.Module);
                                    } else {
                                      handleEdit(
                                        item?.TransactionTypeID,
                                        item?.TransactionTypeID == 23 ||
                                          item?.TransactionTypeID == 24
                                          ? item?.ItemsId
                                          : item?.ID, // 23 Inventory starting value
                                        item?.Type,
                                        item?.RecSaleID
                                      );
                                    }
                                  }}
                                  className="bordertable d-flex align-items-center gap-2"
                                >
                                  {item?.TransactionTypeID == 23 ||
                                  item?.TransactionTypeID == 24 ? (
                                    ""
                                  ) : (
                                    <span
                                      title={
                                        item?.SyncStatus > 0
                                          ? "Synced"
                                          : item?.QuickbookFailureReason
                                      }
                                    >
                                      <i
                                        className={`fa fa-circle ${
                                          item?.SyncStatus > 0
                                            ? "text-success"
                                            : "text-danger"
                                        }`}
                                      ></i>
                                    </span>
                                  )}
                                  {moment(item?.Date).format(
                                    `${dateFormate.toUpperCase()}`
                                  )}
                                </td>
                                <td
                                  onClick={() => {
                                    if (
                                      !accountId &&
                                      item?.TransactionTypeID != 23 &&
                                      item?.TransactionTypeID != 24
                                    ) {
                                      handleRowClick(item?.ID, item?.Module);
                                    } else {
                                      handleEdit(
                                        item?.TransactionTypeID,
                                        item?.TransactionTypeID == 23 ||
                                          item?.TransactionTypeID == 24
                                          ? item?.ItemsId
                                          : item?.ID, // 23 Inventory starting value
                                        item?.Type,
                                        item?.RecSaleID
                                      );
                                    }
                                  }}
                                  className="bordertable"
                                >
                                  {" "}
                                  {item?.RefNo}
                                </td>
                                <td
                                  onClick={() => {
                                    if (
                                      !accountId &&
                                      item?.TransactionTypeID != 23 &&
                                      item?.TransactionTypeID != 24
                                    ) {
                                      handleRowClick(item?.ID, item?.Module);
                                    } else {
                                      handleEdit(
                                        item?.TransactionTypeID,
                                        item?.TransactionTypeID == 23 ||
                                          item?.TransactionTypeID == 24
                                          ? item?.ItemsId
                                          : item?.ID, // 23 Inventory starting value
                                        item?.Type,
                                        item?.RecSaleID
                                      );
                                    }
                                  }}
                                  className="bordertable"
                                >
                                  {" "}
                                  {item?.Type}
                                </td>
                                <td
                                  onClick={() => {
                                    if (
                                      !accountId &&
                                      item?.TransactionTypeID != 23 &&
                                      item?.TransactionTypeID != 24
                                    ) {
                                      handleRowClick(item?.ID, item?.Module);
                                    } else {
                                      handleEdit(
                                        item?.TransactionTypeID,
                                        item?.TransactionTypeID == 23 ||
                                          item?.TransactionTypeID == 24
                                          ? item?.ItemsId
                                          : item?.ID, // 23 Inventory starting value
                                        item?.Type,
                                        item?.RecSaleID
                                      );
                                    }
                                  }}
                                  className="bordertable eliess"
                                >
                                  {" "}
                                  {item?.Payee}
                                </td>
                                {/* Account Select */}
                                <td
                                  onClick={() => {
                                    if (
                                      !accountId &&
                                      item?.TransactionTypeID != 23 &&
                                      item?.TransactionTypeID != 24
                                    ) {
                                      handleRowClick(item?.ID, item?.Module);
                                    } else {
                                      handleEdit(
                                        item?.TransactionTypeID,
                                        item?.TransactionTypeID == 23 ||
                                          item?.TransactionTypeID == 24
                                          ? item?.ItemsId
                                          : item?.ID, // 23 Inventory starting value
                                        item?.Type,
                                        item?.RecSaleID
                                      );
                                    }
                                  }}
                                  className="bordertable eliess"
                                >
                                  {item.IsSplit == 1 ? (
                                    <>
                                      <Box
                                        className="btn-custom-padding col-md-11"
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        data-bs-toggle="modal"
                                        data-bs-target="#SplittingConfirmationModal"
                                        sx={(theme) => ({
                                          borderRadius: "0.3rem",
                                          color: "#343f62",
                                          maxWidth: "18ch",
                                          fontWeight: "700",
                                          textDecoration: "underline",
                                          textUnderlineOffset: "3px",
                                          p: "0.3rem",
                                          cursor: "pointer",
                                        })}
                                        onClick={() =>
                                          Spilliting(item?.SplitRecords)
                                        }
                                        // style={{ width: "100%" }}
                                      >
                                        -Split-
                                      </Box>
                                    </>
                                  ) : (
                                    accountMap[item?.AccountID]
                                  )}
                                </td>
                                <td
                                  onClick={() => {
                                    if (
                                      !accountId &&
                                      item?.TransactionTypeID != 23 &&
                                      item?.TransactionTypeID != 24
                                    ) {
                                      handleRowClick(item?.ID, item?.Module);
                                    } else {
                                      handleEdit(
                                        item?.TransactionTypeID,
                                        item?.TransactionTypeID == 23 ||
                                          item?.TransactionTypeID == 24
                                          ? item?.ItemsId
                                          : item?.ID, // 23 Inventory starting value
                                        item?.Type,
                                        item?.RecSaleID
                                      );
                                    }
                                  }}
                                  className="bordertable"
                                >
                                  {item?.Memo}
                                </td>

                                <td
                                  onClick={() => {
                                    if (
                                      !accountId &&
                                      item?.TransactionTypeID != 23 &&
                                      item?.TransactionTypeID != 24
                                    ) {
                                      handleRowClick(item?.ID, item?.Module);
                                    } else {
                                      handleEdit(
                                        item?.TransactionTypeID,
                                        item?.TransactionTypeID == 23 ||
                                          item?.TransactionTypeID == 24
                                          ? item?.ItemsId
                                          : item?.ID, // 23 Inventory starting value
                                        item?.Type,
                                        item?.RecSaleID
                                      );
                                    }
                                  }}
                                  className="bordertable"
                                >
                                  {/* {"P: "} */}
                                  {item?.isPayment == 1
                                    ? CurrencySymbols(
                                        Number(item?.Payment),
                                        CurrencySymbol,
                                        FractionDigits
                                      )
                                    : ""}
                                </td>
                                <td
                                  onClick={() => {
                                    if (
                                      !accountId &&
                                      item?.TransactionTypeID != 23 &&
                                      item?.TransactionTypeID != 24
                                    ) {
                                      handleRowClick(item?.ID, item?.Module);
                                    } else {
                                      handleEdit(
                                        item?.TransactionTypeID,
                                        item?.TransactionTypeID == 23 ||
                                          item?.TransactionTypeID == 24
                                          ? item?.ItemsId
                                          : item?.ID, // 23 Inventory starting value
                                        item?.Type,
                                        item?.RecSaleID
                                      );
                                    }
                                  }}
                                  className="bordertable"
                                >
                                  {/* {"D: "} */}
                                  {item?.isDeposit == 1
                                    ? CurrencySymbols(
                                        Number(item?.Deposit),
                                        CurrencySymbol,
                                        FractionDigits
                                      )
                                    : ""}
                                </td>
                                <td className="bordertable">
                                  {" "}
                                  <input
                                    value={currentData[startIndex + index]?.cr}
                                    className="form-control form-control-sm"
                                    // style={inputStyles}
                                    style={{
                                      fontSize: "12px",
                                      width: "45px",
                                      cursor: "pointer",
                                    }}
                                    //placeholder="C/R"
                                    type="text"
                                    onClick={() =>
                                      handleRowInputClick(
                                        startIndex + index,
                                        index
                                      )
                                    }
                                    onChange={(event) => event}
                                    disabled={accountId ? true : false}
                                    // readOnly
                                  />
                                </td>
                                <td
                                  onClick={() => {
                                    if (
                                      !accountId &&
                                      item?.TransactionTypeID != 23 &&
                                      item?.TransactionTypeID != 24
                                    ) {
                                      handleRowClick(item?.ID, item?.Module);
                                    } else {
                                      handleEdit(
                                        item?.TransactionTypeID,
                                        item?.TransactionTypeID == 23 ||
                                          item?.TransactionTypeID == 24
                                          ? item?.ItemsId
                                          : item?.ID, // 23 Inventory starting value
                                        item?.Type,
                                        item?.RecSaleID
                                      );
                                    }
                                  }}
                                  className="bordertable"
                                >
                                  {CurrencySymbols(
                                    Number(item.Balance || 0),
                                    CurrencySymbol,
                                    FractionDigits
                                  )}
                                </td>

                                {accountId && (
                                  <td className="bordertable">
                                    {item?.DueDate === "Paid"
                                      ? item?.DueDate
                                      : item?.DueDate &&
                                        moment(item?.DueDate).isValid()
                                      ? moment(item?.DueDate).format(
                                          "MM-DD-YYYY"
                                        )
                                      : ""}
                                  </td>
                                )}
                              </tr>
                            </>
                          )
                        )
                      : currentData?.map((item, index) =>
                          expandedRowId === item?.ID &&
                          expandedRowModule === item.Module ? (
                            <>
                              <tr
                                style={{
                                  borderBottom:
                                    "1px solid var(--primary-color-50)",
                                  marginBottom: "10px",
                                  background: "#F0F4F6",
                                }}
                                key={index}
                              >
                                {/* Date */}
                                <td
                                  style={{
                                    padding: "1px",
                                    textAlign: "-webkit-center",
                                    verticalAlign: "-webkit-baseline-middle",
                                    width: "20%",
                                    fontSize: "12px",
                                  }}
                                >
                                  <CommonDatePicker
                                    FinalDate={item?.Date}
                                    handleDateChange={(event) =>
                                      handleInputChange(
                                        event,
                                        startIndex + index,
                                        "Date",
                                        index
                                      )
                                    }
                                    disabled={
                                      item?.TransactionTypeID == 3 || accountId
                                    }
                                  />
                                </td>

                                {/* Ref No & Type */}
                                <td
                                  style={{
                                    padding: "1px",
                                    verticalAlign: "-webkit-baseline-middle",
                                    width: "36%",
                                    marginLeft: "2px",
                                    lineHeight: "20px",
                                    // border: "1px solid red",
                                    fontSize: "12px",
                                  }}
                                >
                                  {/* Ref No */}
                                  <input
                                    className="form-control form-control-sm col-md-12 "
                                    type="text"
                                    id="refno"
                                    name="refno"
                                    placeholder="Reference No."
                                    style={{
                                      ...inputStyles,
                                      backgroundColor:
                                        item?.TransactionTypeID === 12 ||
                                        item?.TransactionTypeID === 13
                                          ? "dark"
                                          : "",
                                    }}
                                    onChange={(event) =>
                                      handleInputChange(
                                        event?.target?.value,
                                        startIndex + index,
                                        "RefNo",
                                        index
                                      )
                                    }
                                    defaultValue={item?.RefNo}
                                    disabled={
                                      showNewRow
                                        ? item?.TransactionTypeID == 12 ||
                                          item?.TransactionTypeID == 13
                                          ? true
                                          : false
                                        : item?.TransactionTypeID == 12 ||
                                          item?.TransactionTypeID == 13 ||
                                          item?.TransactionTypeID == 3 ||
                                          item?.TransactionTypeID == 5 ||
                                          item?.RefNo == "To Print" ||
                                          (item?.TransactionTypeID == 6 &&
                                            item?.IsOppositeEntry == 1) ||
                                          accountId
                                        ? true
                                        : false
                                    }
                                  />

                                  {/* Transaction Type */}
                                  <Select
                                    options={onRowEditTransaction(item.ID)}
                                    value={filteredTransactions?.find(
                                      (option) =>
                                        option?.value == item?.TransactionTypeID
                                    )}
                                    onChange={(event) =>
                                      handleInputChange(
                                        event,
                                        startIndex + index,
                                        "Type",
                                        index
                                      )
                                    }
                                    backspaceRemovesValue={false}
                                    controlShouldRenderValue={true}
                                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                    className="custom-search-select col-md-11 mt-3 ml-2"
                                    placeholder="Type"
                                    id="Type"
                                    name="Type"
                                    isDisabled={
                                      item?.ID > 0 || accountId ? true : false
                                    } // 11,
                                    // isOptionDisabled={true}
                                  />
                                </td>
                                {/* Payee & Account & Memo */}
                                <td
                                  style={{
                                    padding: "1px",
                                    verticalAlign: "-webkit-baseline-middle",
                                    lineHeight: "20px",
                                    width: "50%",
                                    fontSize: "12px",
                                  }}
                                >
                                  {/* Payee Select */}
                                  {item.IsCustomerSplit == 1 ? (
                                    <>
                                      <button
                                        className="btn btn-sm btn-outline-primary btn-custom-padding col-md-11  mt-2 ml-2"
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        data-bs-toggle="modal"
                                        data-bs-target="#SplittingConfirmationModal"
                                        onClick={() =>
                                          Spilliting(item?.SplitRecords)
                                        }
                                      >
                                        -Split-
                                      </button>
                                    </>
                                  ) : (
                                    <Select
                                      onChange={(event) =>
                                        handleInputChange(
                                          event,
                                          startIndex + index,
                                          "PayeeId",
                                          index
                                        )
                                      }
                                      options={
                                        (item?.TransactionTypeID == 6 ||
                                          item?.TransactionTypeID == 12) &&
                                        accountDropdown.some(
                                          (acc) =>
                                            acc.value == item?.AccountID &&
                                            (acc.AccountFullName ===
                                              "Accounts Receivable (A/R) (Accounts Receivable)" ||
                                              acc.AccountFullName ===
                                                "Accounts Payable (A/P) (Accounts Payable)")
                                        )
                                          ? payeePersonList?.filter((el) => {
                                              const account =
                                                accountDropdown.find(
                                                  (acc) =>
                                                    acc.value ===
                                                    item?.AccountID
                                                );
                                              if (
                                                account?.AccountFullName.includes(
                                                  "Accounts Receivable (A/R) (Accounts Receivable)"
                                                )
                                              ) {
                                                return (
                                                  el?.UserType === "Customer"
                                                );
                                              } else if (
                                                account?.AccountFullName.includes(
                                                  "Accounts Payable (A/P) (Accounts Payable)"
                                                )
                                              ) {
                                                return (
                                                  el?.UserType === "Supplier"
                                                );
                                              }
                                            })
                                          : item?.TransactionTypeID == 6 ||
                                            item?.TransactionTypeID == 13 ||
                                            item?.TransactionTypeID == 14 ||
                                            item?.TransactionTypeID == 20 ||
                                            item?.TransactionTypeID == 21 ||
                                            item?.TransactionTypeID == 15 ||
                                            item?.TransactionTypeID == 12
                                          ? payeePersonList
                                          : payeePersonList?.filter(
                                              (el) =>
                                                el?.UserType ===
                                                item?.PayeeUserType
                                            )
                                      }
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      value={
                                        item?.PayeeId == 0
                                          ? null
                                          : payeePersonList
                                              ?.filter(
                                                (el) =>
                                                  el?.UserType ===
                                                  item?.PayeeUserType
                                              )
                                              ?.find(
                                                (option) =>
                                                  option?.value == item?.PayeeId
                                              )
                                      }
                                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                      placeholder={
                                        "Please Select the Transaction Type First"
                                      }
                                      id="Payee"
                                      name="Payee"
                                      className="custom-search-select col-md-11 ml-2"
                                      isDisabled={
                                        item?.IsPaid > 0 || accountId
                                          ? true
                                          : false
                                      }
                                    />
                                  )}

                                  {/* Account Select */}
                                  {item.IsSplit == 1 ? (
                                    <>
                                      <button
                                        className="btn btn-sm btn-outline-primary btn-custom-padding col-md-11  mt-2 ml-2"
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        data-bs-toggle="modal"
                                        data-bs-target="#SplittingConfirmationModal"
                                        onClick={() =>
                                          Spilliting(item?.SplitRecords)
                                        }
                                      >
                                        -Split-
                                      </button>
                                    </>
                                  ) : (
                                    <Select
                                      onChange={(event) =>
                                        handleInputChange(
                                          event,
                                          startIndex + index,
                                          "AccountID",
                                          index
                                        )
                                      }
                                      value={
                                        accountDropdown.find(
                                          (option) =>
                                            option?.value == item?.AccountID
                                        ) || null
                                      }
                                      placeholder={"Account"}
                                      options={accountDropdown}
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      hideSelectedOptions={true}
                                      isClearable={false}
                                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                      id="AccountId"
                                      name="AccountId"
                                      // isDisabled={true} //item?.IsDefaultBalance == 1}
                                      isDisabled={
                                        showNewRow && index === 0
                                          ? item?.TransactionTypeID == 7 ||
                                            item?.TransactionTypeID == 11 ||
                                            item?.TransactionTypeID == 17 ||
                                            item?.TransactionTypeID == 22
                                            ? true
                                            : false
                                          : item?.TransactionTypeID == 3 || // bill
                                            item?.TransactionTypeID == 5 || // vendor credit
                                            item?.IsPaid > 0 ||
                                            accountId ||
                                            (item.IsOppositeEntry == 1 &&
                                              item?.TransactionTypeID != 13) ||
                                            (item?.TransactionTypeID != 13 &&
                                              item?.FromAccountID !=
                                                selectChartOfAccountId)
                                      }
                                      className="custom-search-select mt-3 col-md-11 ml-2"
                                    />
                                  )}

                                  {/* Memo */}
                                  <input
                                    className="custom-radius-border form-control form-control-sm mt-3 col-md-12 mb-3"
                                    type="text"
                                    style={inputStyles}
                                    placeholder="Memo"
                                    onChange={(event) =>
                                      handleInputChange(
                                        event,
                                        startIndex + index,
                                        "Memo",
                                        index
                                      )
                                    }
                                    value={item?.Memo}
                                    disabled={
                                      item?.IsDefaultBalance == 1 || accountId
                                    }
                                  />
                                </td>

                                {/* Payment */}
                                <td
                                  style={{
                                    // padding: "1px",
                                    textAlign: "-webkit-center",
                                    verticalAlign: "-webkit-baseline-middle",
                                    width: "27%",
                                    fontSize: "12px",
                                  }}
                                >
                                  <>
                                    <input
                                      className="custom-radius-border form-control form-control-sm "
                                      type="text"
                                      style={{
                                        width: "99px",
                                        fontSize: "12px",
                                      }}
                                      // style={inputStyles}
                                      value={` ${CurrencySymbol}${item?.Payment}`}
                                      placeholder="Payment"
                                      onFocus={(e) => e.target.select()}
                                      onChange={(event) => {
                                        let inputValue = event.target.value;
                                        inputValue = inputValue.replace(
                                          /[^\d.]/g,
                                          ""
                                        );

                                        if (
                                          inputValue &&
                                          !inputValue.startsWith(CurrencySymbol)
                                        ) {
                                          inputValue = `${inputValue}`;
                                        }

                                        event.target.value = inputValue;

                                        handleInputChange(
                                          event,
                                          startIndex + index,
                                          "Payment",
                                          index
                                        );
                                      }}
                                      disabled={
                                        showNewRow && index === 0
                                          ? (chartOfAccountId != 2 &&
                                              chartOfAccountId != 4 &&
                                              item?.TransactionTypeID == 6) || // expense
                                            (chartOfAccountId != 2 &&
                                              chartOfAccountId != 4 &&
                                              item?.TransactionTypeID == 7) || // expense
                                            item?.TransactionTypeID == 11 ||
                                            item?.TransactionTypeID == 17 ||
                                            item?.TransactionTypeID == 20 || // CC Expense
                                            item?.TransactionTypeID == 12 //
                                            ? true
                                            : false
                                          : item?.isPayment == 0 ||
                                            item?.IsPaid > 0 ||
                                            accountId ||
                                            item?.IsSplit == 1
                                          ? true
                                          : false
                                      }
                                    />

                                    {showNewRow &&
                                    (item?.TransactionTypeID == 7 ||
                                      item?.TransactionTypeID == 11) ? (
                                      <>
                                        <Select
                                          onChange={(event) =>
                                            handleInputChange(
                                              event,
                                              startIndex + index,
                                              "BillInvoice",
                                              index
                                            )
                                          }
                                          value={
                                            billInvoiceSelect
                                              ? pendinginvoice?.find(
                                                  (el) =>
                                                    el?.value ==
                                                    billInvoiceSelect
                                                )
                                              : null
                                          }
                                          options={pendinginvoice}
                                          backspaceRemovesValue={false}
                                          controlShouldRenderValue={true}
                                          hideSelectedOptions={true}
                                          styles={selectDropdownStyles}
                                          className="col-md-11 mt-3 custom-search-select"
                                          placeholder={
                                            item?.TransactionTypeID == 7
                                              ? "Bill No."
                                              : item?.TransactionTypeID == 11
                                              ? "Invoice No"
                                              : ""
                                          }
                                          id="BillInvoice"
                                          name="BillInvoice"
                                        />
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                </td>

                                {/* Deposit & save*/}
                                <td
                                  style={{
                                    padding: "1px",
                                    textAlign: "-webkit-center",
                                    verticalAlign: "-webkit-baseline-middle",
                                  }}
                                >
                                  <input
                                    className="form-control form-control-sm"
                                    type="text"
                                    style={{ width: "99px", fontSize: "12px" }}
                                    // style={inputStyles}
                                    placeholder="Deposit"
                                    value={`${CurrencySymbol}${item?.Deposit}`}
                                    onChange={(event) => {
                                      let inputValue = event.target.value;

                                      inputValue = inputValue.replace(
                                        /[^\d.]/g,
                                        ""
                                      );

                                      if (
                                        inputValue &&
                                        !inputValue.startsWith(CurrencySymbol)
                                      ) {
                                        inputValue = `${inputValue}`;
                                      }

                                      event.target.value = inputValue;

                                      handleInputChange(
                                        event,
                                        startIndex + index,
                                        "Deposit",
                                        index
                                      );
                                    }}
                                    disabled={
                                      showNewRow && index === 0
                                        ? item?.TransactionTypeID == 21 || // cc credit
                                          ((chartOfAccountId == 2 ||
                                            chartOfAccountId == 4) &&
                                            item?.TransactionTypeID == 6) ||
                                          ((chartOfAccountId == 2 ||
                                            chartOfAccountId == 4) &&
                                            item?.TransactionTypeID == 7)
                                          ? true
                                          : false
                                        : item?.isDeposit == 0 ||
                                          item?.IsPaid > 0 ||
                                          accountId ||
                                          item?.IsSplit == 1
                                        ? true
                                        : false
                                    }
                                  />

                                  {showNewRow &&
                                  (item?.TransactionTypeID == 7 ||
                                    item?.TransactionTypeID == 11) ? (
                                    <div>
                                      {labelinvoice?.length > 0 &&
                                        labelinvoice?.map((item, index) => {
                                          return (
                                            <div>
                                              <p key={index}>
                                                {item.label
                                                  .split("(")[0]
                                                  .trim()}
                                                : {item.total}
                                              </p>
                                            </div>
                                          );
                                        })}
                                    </div>
                                  ) : (
                                    ""
                                  )}

                                  {item?.Type === "Opening Balance" ||
                                  accountId ||
                                  item?.Deleted === 1 ||
                                  !handleCheckPermission(item?.Type, "Save") ? (
                                    ""
                                  ) : (
                                    <button
                                      type="button"
                                      class="btn btn-primary btn-sm  "
                                      style={{
                                        marginLeft: "10px",
                                        marginTop: "15px",
                                      }}
                                      onClick={() =>
                                        // showNewRow
                                        item?.ID == 0
                                          ? handleSubmit("add")
                                          : handleSubmit(
                                              "edit",
                                              startIndex + index,
                                              item.IsSplit,
                                              index
                                            )
                                      }
                                    >
                                      Save
                                    </button>
                                  )}
                                </td>

                                {/* Cr & Cancle */}
                                <td
                                  style={{
                                    padding: "1px",
                                    textAlign: "-webkit-center",
                                    verticalAlign: "-webkit-baseline-middle",
                                  }}
                                >
                                  <>
                                    <input
                                      value={
                                        currentData[startIndex + index]?.cr
                                      }
                                      className="form-control form-control-sm"
                                      // style={inputStyles}
                                      style={{
                                        fontSize: "12px",
                                        width: "45px",
                                        cursor: "pointer",
                                      }}
                                      //placeholder="C/R"
                                      type="text"
                                      onClick={() =>
                                        handleRowInputClick(
                                          startIndex + index,
                                          index
                                        )
                                      }
                                      onChange={(event) => event}
                                      disabled={accountId ? true : false}
                                      // readOnly
                                    />

                                    <button
                                      type="button"
                                      class="btn btn-secondary btn-sm"
                                      onClick={() =>
                                        handleRowClick(item?.ID, item?.Module)
                                      }
                                      style={{
                                        marginTop: "15px",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      {" "}
                                      cancel
                                    </button>
                                  </>
                                </td>

                                {/* Balance & Edit */}
                                <td
                                  style={{
                                    padding: "1px",
                                    textAlign: "-webkit-center",
                                    verticalAlign: "-webkit-baseline-middle",
                                  }}
                                >
                                  {item?.Balance < 0 ? (
                                    <p
                                      className="mb-2 font-bold"
                                      style={{
                                        color: "var(--error-main-color)",
                                      }}
                                    >
                                      {CurrencySymbols(
                                        Number(item.Balance).toFixed(2),
                                        CurrencySymbol,
                                        FractionDigits
                                      )}
                                    </p>
                                  ) : selectTransactionType === 1 ||
                                    selectTransactionType === undefined ? (
                                    <p
                                      className="mb-2 font-bold"
                                      style={{
                                        color: "var(--success-main-color)",
                                      }}
                                    >
                                      {CurrencySymbols(
                                        Number(item.Balance).toFixed(2),
                                        CurrencySymbol,
                                        FractionDigits
                                      )}
                                    </p>
                                  ) : startIndex + index === 0 ? (
                                    <>
                                      <p>(Only displayed with</p>
                                      <p>date/reconcile </p>
                                      <p>status sort)</p>
                                    </>
                                  ) : (
                                    "n/a"
                                  )}

                                  {accountId ||
                                  showNewRow ||
                                  !handleCheckPermission(item?.Type, "Edit")
                                    ? ""
                                    : item?.Type !== "Opening Balance" &&
                                      item?.Deleted !== 1 && (
                                        <button
                                          type="button"
                                          class="btn btn-secondary btn-sm mb-1 mr-1"
                                          style={{
                                            marginLeft: "10px",
                                            marginTop: "20px",
                                          }}
                                          onClick={() =>
                                            handleEdit(
                                              item?.TransactionTypeID,
                                              item?.TransactionTypeID == 23 ||
                                                item?.TransactionTypeID == 24
                                                ? item?.ItemsId
                                                : item?.ID, // 23 Inventory starting value
                                              item?.Type,
                                              item?.RecSaleID
                                            )
                                          }
                                        >
                                          Edit
                                        </button>
                                      )}
                                </td>

                                {/* Delete */}
                                <td
                                  style={{
                                    padding: "1px",
                                    textAlign: "-webkit-center",
                                    verticalAlign: "-webkit-baseline-middle",
                                  }}
                                >
                                  <td></td>
                                  <div></div>
                                  <td>{""}</td>
                                  {accountId ||
                                  (showNewRow && index === 0) ||
                                  item?.Deleted === 1 ||
                                  !handleCheckPermission(
                                    item?.Type,
                                    "Delete"
                                  ) ? (
                                    ""
                                  ) : item?.IsDefaultBalance != 1 ? (
                                    <div class="row">
                                      <div class="col-md-12">
                                        {
                                          <>
                                            {item.IsDefaultBalance == 0 && (
                                              <>
                                                <button
                                                  type="button"
                                                  class="btn btn-secondary btn-sm  mt-1"
                                                  style={{
                                                    //marginLeft: "20px",
                                                    marginTop: "25px",
                                                  }}
                                                  onClick={() =>
                                                    handleDeleteClick(
                                                      item,
                                                      startIndex + index
                                                    )
                                                  }
                                                >
                                                  Delete
                                                </button>
                                              </>
                                            )}
                                          </>
                                        }
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}

                                  <div
                                    className={`modal ${
                                      stateModal.visible === startIndex + index
                                        ? "d-block"
                                        : ""
                                    }`}
                                    tabIndex="-1"
                                    style={{ background: "rgba(0,0,0,0.2)" }}
                                  >
                                    <div className="modal-dialog modal-sm modal-dialog-centered">
                                      <div className="modal-content">
                                        <div className="modal-header">
                                          <h5 className="title-model">
                                            Confirmation
                                          </h5>
                                          <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            onClick={handleClose}
                                          >
                                            <span aria-hidden="true">×</span>
                                          </button>
                                        </div>
                                        <div className="modal-body">
                                          <div className="row">
                                            <div className="col-lg-12">
                                              <p className="mb-2">
                                                Are you sure you want to delete
                                                this row?
                                              </p>
                                              {false && (
                                                <>
                                                  <p className=" text-danger">
                                                    Note: Credit delete need to
                                                    deleted manually
                                                  </p>
                                                  <p className=" text-danger">
                                                    from the QuickBook because
                                                    it won't SYNC.
                                                  </p>
                                                </>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="modal-footer justify-content-center">
                                          <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={() =>
                                              handleConfirmDelete()
                                            }
                                            checkafter
                                          >
                                            Delete
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={handleCancelDelete}
                                          >
                                            Cancel
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </>
                          ) : (
                            <>
                              <tr
                                key={index}
                                onClick={() => {
                                  if (
                                    !accountId &&
                                    item?.TransactionTypeID != 23 &&
                                    item?.TransactionTypeID != 24
                                  ) {
                                    handleRowClick(item?.ID, item?.Module);
                                  } else {
                                    handleEdit(
                                      item?.TransactionTypeID,
                                      item?.TransactionTypeID == 23 ||
                                        item?.TransactionTypeID == 24
                                        ? item?.ItemsId
                                        : item?.ID, // 23 Inventory starting value
                                      item?.Type,
                                      item?.RecSaleID
                                    );
                                  }
                                }}
                                style={{
                                  cursor: "pointer",
                                  backgroundColor:
                                    index % 2 === 0 ? "#f2f2f2" : "#ffffff",
                                }}
                              >
                                <td className="borderleft d-flex align-items-center gap-2">
                                  {item?.TransactionTypeID == 23 ||
                                  item?.TransactionTypeID == 24 ? (
                                    ""
                                  ) : (
                                    <span
                                      title={
                                        item?.SyncStatus > 0
                                          ? "Synced"
                                          : item?.QuickbookFailureReason
                                      }
                                    >
                                      <i
                                        className={`fa fa-circle ${
                                          item?.SyncStatus > 0
                                            ? "text-success"
                                            : "text-danger"
                                        }`}
                                      ></i>
                                    </span>
                                  )}
                                  {moment(item?.Date).format(
                                    `${dateFormate.toUpperCase()}`
                                  )}
                                </td>
                                <td className="borderleft"> {item?.RefNo}</td>

                                <td className="borderleft"> {item?.Payee}</td>

                                <td className="borderleft">
                                  {/* {"P: "} */}
                                  {item?.isPayment == 1
                                    ? CurrencySymbols(
                                        Number(item.Payment),
                                        CurrencySymbol,
                                        FractionDigits
                                      )
                                    : ""}
                                </td>
                                <td className="borderleft">
                                  {/* {"D: "} */}
                                  {item?.isDeposit == 1
                                    ? CurrencySymbols(
                                        Number(item.Deposit),
                                        CurrencySymbol,
                                        FractionDigits
                                      )
                                    : ""}
                                </td>
                                <td className="borderleft"> {item?.cr}</td>
                                <td className="borderright">
                                  {CurrencySymbols(
                                    Number(item.Balance || 0),
                                    CurrencySymbol,
                                    FractionDigits
                                  )}
                                </td>
                              </tr>
                              <tr
                                onClick={() => {
                                  if (
                                    !accountId &&
                                    item?.TransactionTypeID != 23 &&
                                    item?.TransactionTypeID != 24
                                  ) {
                                    handleRowClick(item?.ID, item?.Module);
                                  } else {
                                    handleEdit(
                                      item?.TransactionTypeID,
                                      item?.TransactionTypeID == 23 ||
                                        item?.TransactionTypeID == 24
                                        ? item?.ItemsId
                                        : item?.ID, // 23 Inventory starting value
                                      item?.Type,
                                      item?.RecSaleID
                                    );
                                  }
                                }}
                                style={{
                                  cursor: "pointer",
                                  backgroundColor:
                                    index % 2 === 0 ? "#f2f2f2" : "#ffffff",
                                }}
                              >
                                <td className="borderleft"></td>
                                <td className="borderleft"> {item?.Type}</td>
                                {/* Account Select */}
                                <td className="borderleft">
                                  {item.IsSplit == 1 ? (
                                    <>
                                      <Box
                                        className="btn-custom-padding col-md-11"
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        data-bs-toggle="modal"
                                        data-bs-target="#SplittingConfirmationModal"
                                        sx={(theme) => ({
                                          borderRadius: "0.3rem",
                                          color: "#343f62",
                                          maxWidth: "18ch",
                                          fontWeight: "700",
                                          textDecoration: "underline",
                                          textUnderlineOffset: "3px",
                                          p: "0.3rem",
                                          cursor: "pointer",
                                        })}
                                        onClick={() =>
                                          Spilliting(item?.SplitRecords)
                                        }
                                        // style={{ width: "100%" }}
                                      >
                                        -Split-
                                      </Box>
                                    </>
                                  ) : (
                                    accountMap[item?.AccountID]
                                  )}
                                </td>
                                <td className="borderleft"></td>
                                {accountId ? (
                                  <td className="borderleft">
                                    {item?.DueDate === "Paid"
                                      ? item?.DueDate
                                      : item?.DueDate &&
                                        moment(item?.DueDate).isValid()
                                      ? moment(item?.DueDate).format(
                                          "MM-DD-YYYY"
                                        )
                                      : ""}
                                  </td>
                                ) : (
                                  <td className="borderleft"></td>
                                )}
                                <td className="borderleft"></td>
                                <td className="borderright"></td>
                              </tr>
                              <tr
                                className="borderbottom"
                                onClick={() => {
                                  if (
                                    !accountId &&
                                    item?.TransactionTypeID != 23 &&
                                    item?.TransactionTypeID != 24
                                  ) {
                                    handleRowClick(item?.ID, item?.Module);
                                  } else {
                                    handleEdit(
                                      item?.TransactionTypeID,
                                      item?.TransactionTypeID == 23 ||
                                        item?.TransactionTypeID == 24
                                        ? item?.ItemsId
                                        : item?.ID, // 23 Inventory starting value
                                      item?.Type,
                                      item?.RecSaleID
                                    );
                                  }
                                }}
                                style={{
                                  cursor: "pointer",
                                  backgroundColor:
                                    index % 2 === 0 ? "#f2f2f2" : "#ffffff",
                                }}
                              >
                                <td className="borderleft"></td>
                                <td className="borderleft"> </td>
                                <td className="borderleft">{item?.Memo}</td>
                                <td className="borderleft"></td>
                                <td className="borderleft"></td>
                                <td className="borderleft"></td>
                                <td className="borderright"></td>
                              </tr>
                            </>
                          )
                        )}
                  </tbody>
                </table>
                <button
                  onClick={scrollToTop}
                  className="btn btn-primary"
                  style={{
                    position: "fixed",
                    bottom: "20px",
                    right: "20px",
                    zIndex: 1000,
                    padding: "10px 20px",

                    color: "#fff",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  Scroll to Top
                </button>
                <div className="d-flex justify-content-between">
                  <button
                    className="btn btn-sm btn-secondary me-2"
                    onClick={() => navigate(-1)}
                    style={{ marginTop: "20px" }}
                  >
                    Back
                  </button>
                  <div style={{ marginTop: "20px" }}>
                    <button
                      className="btn btn-sm btn-secondary me-2"
                      onClick={() => handlePageChange("first")}
                      disabled={pageNum === 1}
                    >
                      First
                    </button>
                    <button
                      className="btn btn-sm btn-secondary me-2"
                      onClick={() => handlePageChange("previous")}
                      disabled={pageNum === 1}
                    >
                      Previous
                    </button>
                    <span>
                      Page {pageNum} of {totalPages} (Total Records:{" "}
                      {totalRecords}){" "}
                    </span>
                    <button
                      className="btn btn-sm btn-secondary me-2"
                      onClick={() => handlePageChange("next")}
                      disabled={pageNum === totalPages}
                    >
                      Next
                    </button>
                    <button
                      className="btn btn-sm btn-secondary me-2"
                      onClick={() => handlePageChange("last")}
                      disabled={pageNum === totalPages}
                    >
                      Last
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SplittingConfirmationModal SplitData={splits} />
    </>
  );
}

export default ViewRegisterQuickbookSc;
 